import { DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, finalize, forkJoin, lastValueFrom, of, Subscription } from 'rxjs';
import { MarketInfoService } from 'src/app/services/MarketInfoService.service';
import { PaymentService } from 'src/app/services/paymentService.service';
import { RentalService } from 'src/app/services/Rental.service';
import { VendorService } from 'src/app/services/Vendor.service';
import { customCurrencyPipe } from 'src/app/Shared/customCurrency.pipe';
import Swal from 'sweetalert2';
import { DiscountType, EPaymentGateway } from 'src/app/Shared/enum';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/services/General.service';
interface DateString {
  startDate: string;
}

@Component({
  selector: 'app-booking-details-weekly-monthly',
  templateUrl: './booking-details-weekly-monthly.component.html',
  styleUrls: ['./booking-details-weekly-monthly.component.scss']
})
export class BookingDetailsWeeklyMonthlyComponent  implements OnInit, OnDestroy {
  @Input() rentalType;
  RentalTypeText;
  voidPayment = false;
  selectedBooths = [];
  selectedMonthlyBooths =[]
  public loaderIcon: Promise<boolean>;
  private subscriptions: Subscription[] = [];
  @Input() vendorId;
  @Input() marketId;
  companyId;
  processPayment = false;
  paymentAmount = 0;
  vendorProducts=[];
  vendorDiscountPlans=[];
  priorBalance;
  paymentGatewayCredentials;
  PromptRenewOther = false;
  processCreditCardOnline;
  verifoneId;
  paymentOnly = false;
  masterRentChargeforResOtherItems = false;
  openConfirmationPage = false;
  creditCardAmount = 0;
  accountReceipId;
  selectedWeeklyBooths;
  private clickTimeout: any;
  selectedMarketDays = [];
  rentEndPeriodIndex;
  private monthEndDateCache = new Map<string, Date>();
  private monthEndDateRequests = new Map<string, Promise<Date>>();
  @Output() hideTopHeaders = new EventEmitter<any>();
  @Output() cancelBooking = new EventEmitter<void>();
  totalRentalCharge = 0.00;
  totalOtherRentalCharge = 0.00;
  totalSalesTax = 0.00;
  totalSecondLeveltax = 0.00
  totalCharge = 0.00;
  otherItemList = [];
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };
  bookingDetailsForm: FormGroup;
  selectedOtherItems = [];
  applyCCCharge = false;
  CCFeeType = 0;
  CcfeeinPercentage;
  AllowPartialPay;
  vendorRentalDays;
  marketDayCountForResale = 0;
  actualTotalDue = 0;
  renewAllBoothsFromGrid;
  keyedInTransaction = true;
  MonthlyBookingEndDate = false;
  transactionType="CREDITSALE"
  monthlyMarketDays = [];
  allrentedOtherItems = [];
  showDetails: boolean = false;
  ResaleNumberRequired  = false;
  DaysSellWithoutResaleNumber;
  OtherChargesPeriod = false;
  BusinessLicenseNumberRequired  = false;
  DaysSellWithoutBusiLicNumber;
  resaleOptionSelected;
  exemptResale = false;
  resaleNo = "";
  // Flow (monthly renew, weekly renew or extend rental) that opened the resale popup:
  // resumed once the resale number is entered, reverted if the popup is closed without it.
  private resaleModalFlow: { resume: () => Promise<void>; cancel: () => void };
  businessLicenseNumber;
  businessLicenseExpiryDate;
  secondTaxName="";
  weeklyMarketDays =[];
  @ViewChild('modalResaleNo', { static: false }) modalResaleNo: ElementRef;
  totalDiscountCharge;
  applyRenewalFee = false;
  bookingRenewalFeeId;
  renewalFeeAmount = 0
  allowRenewalsFee = false;
  allowRenewalsFeeId;
  onlineBookingFeeAmount = 0;
  onlineBookingFeeApplied = false;
  rules: any[] = [];
  allowWeeklyRentalRenewal = false;
  allowMonthlyRentalRenewal = false;
  allowOtherItemRenewal = false;
  preventVendorUncheckOtherItemRenewal = false;
  paymentAdjustedWithPriorBal = false;
  savePayment = false;
  applyLateFee = false;
  UnchkBoothOnOthChgRemoval = false;
  FirstMondayCustomChanges: boolean = false;
  displayCityTax: boolean = false;
  displaySalesTax: boolean = false;
  isStripeEnabled = false;
  isOpenEdgenEnabled = false;
  constructor(
    private formbuilder: FormBuilder,
    private route: ActivatedRoute,
    public router: Router,
    public rentalService: RentalService,
    public vendorService: VendorService,
    private customCurrency: customCurrencyPipe,
    private paymentService: PaymentService,
    private toastr: ToastrService,
    private generalService: GeneralService,
    private marketInfoService: MarketInfoService,
    private datePipe: DatePipe) {
    this.bookingDetailsForm = this.formbuilder.group({
      priorBalance: [this.customCurrency.transform('0')],
      totalCharge: [this.customCurrency.transform('0')],
      paymentAmount: [this.customCurrency.transform('0')],
      convenienceFee: [this.customCurrency.transform('0')],
      totalPayment: [this.customCurrency.transform('0')],
      balanceDue: [this.customCurrency.transform('0')],
      rentalCharge: [this.customCurrency.transform('0')],
      otherCharge: [this.customCurrency.transform('0')],
      discount: [this.customCurrency.transform('0')],
      additionalCharge: [this.customCurrency.transform('0')],
      totalSalesTax: [this.customCurrency.transform('0')],
      totalSecondLeveltax: [this.customCurrency.transform('0')],
      rules: this.formbuilder.array(this.initializeRulesArray()),
      paymentLateFee: [this.customCurrency.transform('0')]
    });

    this.subscriptions.push(
      this.bookingDetailsForm.get('totalCharge')?.valueChanges.subscribe((val) => {
        if (!this.AllowPartialPay) {
          //var totalCharge = this.getActualAmountFromInp(val.toString());
          // var convenienceFee = this.getActualAmountFromInp(this.bookingDetailsForm.get('convenienceFee').value);
          // if (convenienceFee > 0) {
          //   val = totalCharge - convenienceFee;
          //   val = this.customCurrency.transform(val);
          // }
          this.bookingDetailsForm.get('paymentAmount')?.setValue(val, { emitEvent: false });
        }
        this.calculateBalance();
      })
    );
  }

  ngOnInit(): void {
    const rentalTypeMapping: { [key: string]: string } = {
      '2': 'Monthly',
      '3': 'Weekly'
    };

    this.rentalType = parseInt(this.rentalType);
    this.RentalTypeText = rentalTypeMapping[this.rentalType] || '';
    this.marketInfoService.setMarketId(this.marketId);
    this.getMonthlyMarketDays();
    this.getOtherRentalItems();
    //   this.getVendorProducts();
    this.getVendorBalances();
    this.getCCCredentials();
    this.getLateFeeForVendorLatePayment();
    this.getWebRentalSetting();
    // Rental payment settings (resale/business license rules) are applied in getMonthlyMarketDays,
    // before the bookings load, from the same getRentalSettings response.
    this.getMarketRulesAndRegulations();
  }

  getLateFeeForVendorLatePayment() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.rentalService.getLateFeeForVendorLatePayment(this.marketId, this.vendorId).subscribe((res: any) => {
      if (res) {
        const latefee = this.customCurrency.transform(res?.LateFeeAmount);
        this.bookingDetailsForm.get('paymentLateFee').setValue(latefee)
        if (res?.LateFeeAmount > 0) {
          this.calculateBalance();
        }
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  private otherItemListLoad: Promise<void> | null = null;

  getOtherRentalItems(): Promise<void> {
    if (!this.otherItemListLoad) {
      this.otherItemListLoad = lastValueFrom(this.rentalService.getOtherRentalItems(this.marketId))
        .then((response: any) => {
          if (response) {
            response.map((el, i) => {
              const ob = {
                Id: el.OtherItemId,
                OtherItem: el.OtherItem,
                OtherItemCharge: this.customCurrency.transform(el.OtherItemCombinedMonthlyCharge),
                Quantity: 0,
                OtherItemtotal: this.customCurrency.transform('0'),
                Recurring: el.Recurring,
                othChgBooths: "none",
                CompanyOtherRentalId: el.OtherItemCompanyId,
              }
              this.otherItemList.push(ob);
            });
          }
        })
        .catch(err => console.error('[OtherCharges] failed to load other items', err));
    }
    return this.otherItemListLoad;
  }

  private resolveRenewalCharge(item: any): string | null {
    debugger;
    const master = this.otherItemList.find(e => e.Id == item.Id);
    const masterCharge = master ? master.OtherItemCharge : null;

    const rented = (this.allrentedOtherItems || [])
      .filter(e => e.OtherItemId == item.Id && e.Reference == item.Reference)
      .sort((a, b) => String(b.YearMonth).localeCompare(String(a.YearMonth)))[0];
    const rentedCharge = rented ? this.customCurrency.transform(String(rented.OtherCharge ?? 0)) : null;

    const order = this.masterRentChargeforResOtherItems ? [masterCharge, rentedCharge] : [rentedCharge, masterCharge];
    const nonZero = order.find(c => !!c && this.getActualAmountFromInp(c) !== 0);
    const chosen = nonZero ?? order.find(c => !!c) ?? null;

    console.log('[OtherCharges] charge for', item.OtherItem, { itemId: item.Id, inMasterList: !!master,
      masterCharge, rentedCharge, useMasterCharge: this.masterRentChargeforResOtherItems, chosen });
    return chosen;
  }

  initializeRulesArray(): FormGroup[] {
    return this.rules.map(rule => this.formbuilder.group({
      isChecked: [false],  // Initialize checkbox with false
      rulesAndRegualtions: [rule.rulesAndRegualtions],
      AgreementLinkRequired: [rule.AgreementLinkRequired],
      AgreementBlobURL: [rule.AgreementBlobURL],
      AgreementLinkTextContent: [rule.AgreementLinkTextContent]
    }));
  }

  updateArrayDirectly(index: number, updatedValue: any) {
    const isChecked = (event.target as HTMLInputElement).checked;
    const control = this.rulesFormArray.at(index);
    if (control) {
      this.bookingDetailsForm.value['rules'][index].isChecked = isChecked;
    }
  }

  getMarketRulesAndRegulations() {
    this.subscriptions.push(this.generalService.getWebrentalMarketRules(this.marketId).subscribe((rules: any) => {
      if (rules) {
        const rulesArray = this.bookingDetailsForm.get('rules') as FormArray;
        rules.forEach(rule => {
          var agreementURL = this.rentalType == 2 ? rule.MonthlyAgreementBlobURL :
            this.rentalType == 3 ? rule.WeeklyAgreementBlobURL : "";

          if (!agreementURL) {
            agreementURL = rule.AgreementBlobURL ?? "";
          }

          if (!rule.AgreementLinkRequired || (rule.AgreementLinkRequired && agreementURL)) {
            rulesArray.push(this.formbuilder.group({
              id: rule.ID,
              isChecked: false,
              rulesAndRegualtions: rule.Rules,
              AgreementLinkRequired : rule.AgreementLinkRequired ?? false,
              AgreementLinkTextContent: rule.AgreementLinkTextContent ?? "",
              AgreementBlobURL: agreementURL
            }));
          }
        });
      }
    }));
  }

  allCheckboxesCheckedValidator(control: AbstractControl) {
    var allChecked = this.bookingDetailsForm.value['rules'].filter(e=>!e.isChecked).length > 0 ? false : true;
    return allChecked;
  }

  get rulesFormArray() {
    return this.bookingDetailsForm.value['rules'] as FormArray;
  }

  getVendorProducts() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.rentalService.GetVendorProductsById(this.marketId, this.vendorId).subscribe((res: any) => {
      if (res) {
        this.vendorProducts = res.body;
        this.loaderIcon = Promise.resolve(false);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  ClosePaymentPage(){
    this.processPayment = false;
    this.hideTopHeaders.emit(false);
  }

  cancel() {
    this.cancelBooking.emit();
  }

  async getMonthlyMarketDays() {
    try {
      const { response, resRentalSettings, vendorProducts, weeklyMarket, resCustomSettings, vendorSettings, companyIdRes } = await lastValueFrom(
        forkJoin({
          response: this.marketInfoService.getMonthlyMarketDays(this.marketId),
          weeklyMarket: this.marketInfoService.getWeeklyMarketDays(this.marketId),
          resRentalSettings: this.rentalService.getRentalSettings(this.marketId),
          vendorProducts: this.rentalService.GetVendorProductsById(this.marketId, this.vendorId),
          resCustomSettings: this.rentalService.getCustomSettings(this.marketId),
          vendorSettings: this.vendorService.getMarketVendorSettings(this.vendorId, this.marketId).pipe(catchError(() => of(null))),
          companyIdRes: this.generalService.getCompanyId().pipe(catchError(() => of(null)))
        })
      );

      // Loaded before the bookings so the resale popup is only shown when the vendor has no resale number on file
      this.applyMarketVendorSettings(vendorSettings);
      // Company id first: the rental payment settings have company-specific overrides
      this.companyId = companyIdRes?.Id;
      if (response) this.monthlyMarketDays = response;
      if (weeklyMarket) this.weeklyMarketDays = weeklyMarket;
      if (vendorProducts) this.vendorProducts = vendorProducts.body;

      if (resRentalSettings) {
        this.applyRentalPaymentSettings(resRentalSettings);
        this.MonthlyBookingEndDate = resRentalSettings.MonthlyBookingEndDate;
        this.applyLateFee = resRentalSettings.ApplyLateFee ?? false;
        this.OtherChargesPeriod = resRentalSettings.OtherChargesPeriod ?? false;

        if (this.MonthlyBookingEndDate && this.rentalType == 4) {
          const currentDate = new Date();
          const currentMonth = currentDate.getMonth() + 1;
          const currentYearMonth = `${currentDate.getFullYear()}${currentMonth < 10 ? '0' : ''}${currentMonth}`;
          const currentMonthEndDate = await this.getMonthEndingDateFromSetting(currentYearMonth);

          if (currentMonthEndDate <= currentDate) {
            const currentDateYearAndMonth = this.datePipe.transform(currentDate, 'MMMM yyyy');
            this.monthlyMarketDays = response.filter(e => e.RentalMonths !== currentDateYearAndMonth);
          }
        }
      }

      if (resCustomSettings) {
        this.FirstMondayCustomChanges = resCustomSettings.FirstMondayCustomChanges;
        this.calculateConvenienceFee();
      }

      if (this.rentalType == 2) {
        await Promise.all([
          this.getMonthlyBookings(),
          this.getMonthlyOtherRentals()
        ]);
      } else if (this.rentalType == 3) {
        await Promise.all([
          this.getWeeklyRental(),
          this.getWeeklyOtherRentals()
        ]);
      }
      this.applyOnlineBookingFeeIfNeeded();

    } catch (err) {
      console.error('Error in getMonthlyMarketDays:', err);
      this.loaderIcon = Promise.resolve(false);
    }
  }

  getMonthIndex(monthString: string): number {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const monthIndex = months.findIndex(month => month.toLowerCase() === monthString.toLowerCase());
    return monthIndex !== -1 ? monthIndex : 0;
  }

  getVendorBalances() {
    this.rentalService.getVendorBalances(this.vendorId, this.marketId).subscribe((res: any) => {
      if (res) {
        this.priorBalance = res.PriorBalance;
        this.actualTotalDue = res.PriorBalance;
        this.bookingDetailsForm.patchValue({
          priorBalance: this.customCurrency.transform(this.priorBalance),
          totalCharge: this.customCurrency.transform(this.priorBalance)
        });
      }
    });
  }

  getMonthEndDate(inputDate: Date): Date {
    const nextMonthFirstDay = new Date(inputDate);
    nextMonthFirstDay.setMonth(nextMonthFirstDay.getMonth() + 1, 1);
    const monthEndDate = new Date(nextMonthFirstDay);
    monthEndDate.setDate(monthEndDate.getDate() - 1);
    return monthEndDate;
  }

  toggleDetails(index: number) {
    this.selectedMonthlyBooths[index].showDetails = !this.selectedMonthlyBooths[index].showDetails;
  }

  toggleOtherItemsDetails(index: number) {
    this.selectedOtherItems[index].showOtherItemsDetails = !this.selectedOtherItems[index].showOtherItemsDetails;
  }

  toggleWeeklyBookingDetails(index: number) {
    this.selectedWeeklyBooths[index].showDetails = !this.selectedWeeklyBooths[index].showDetails;
  }

  async getMonthlyBookings(): Promise<void> {
    this.loaderIcon = Promise.resolve(true);
    this.selectedMonthlyBooths = [];
    const sub = this.rentalService.getMonthlyBookings(this.marketId, this.vendorId).subscribe(
      async (res: any[]) => {
        if (res?.length) await this.bindMonthlyRentalData(res);
      },
      () => { this.loaderIcon = Promise.resolve(false); }
    );
    this.subscriptions.push(sub);
  }

  async bindMonthlyRentalData(existingBooths: any[]): Promise<void> {
    await Promise.all(existingBooths.map(el => this.processBoothData(el)));
    this.selectedMonthlyBooths.sort((a, b) =>
      a.BoothNumber.localeCompare(b.BoothNumber, undefined, { numeric: true, sensitivity: 'base' })
    );
    this.applyRentalRenewalAvailability();
    await this.handleMonthlyEndDateChange();
    this.loaderIcon = Promise.resolve(false);
  }

  async processBoothData(el: any) {
    const StartDateList = [];
    var initialStartDate;
    var marketDays = 0;
    var marketDay;
    const today: Date = new Date(new Date().toDateString());

    var startDate = new Date(el.RentalStartDate);
    var endDate = new Date(el.RentalEndDate);

    if (el.Status == "R" && startDate < today) {
      startDate = today;
      initialStartDate = startDate;
      endDate = this.getMonthEndDate(startDate);
    }

    var selectedDayOfWeek = new Date(el.RentalStartDate).getDay();
    marketDay = this.datePipe.transform(el.RentalStartDate, 'EEE');
    let currentDay = new Date(startDate);

    while (currentDay <= endDate) {
      if (currentDay.getDay() === selectedDayOfWeek) {
        marketDays += 1;
        StartDateList.push({ startDate: this.datePipe.transform(new Date(currentDay), 'MMM d, y') });
      }

      if (this.datePipe.transform(currentDay, 'MM/dd/yyyy') == this.datePipe.transform(endDate, 'MM/dd/yyyy')) {
        if (StartDateList && StartDateList.length == 0) {
          endDate.setDate(endDate.getDate() + 1);
          endDate = this.getMonthEndDate(endDate);
        }
      }
      currentDay.setDate(currentDay.getDate() + 1);
    }

    const compareDates = (a: DateString, b: DateString): number => {
      const dateA = new Date(a.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
      const dateB = new Date(b.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
      return dateA - dateB;
    };
    StartDateList.sort(compareDates);
    switch (el) {
      case 1: marketDay = 'Sun'
        break;
      case 2: marketDay = 'Mon'
        break;
      case 3: marketDay = 'Tue'
        break;
      case 4: marketDay = 'Wed'
        break;
      case 5: marketDay = 'Thu'
        break;
      case 6: marketDay = 'Fri'
        break;
      case 7: marketDay = 'Sat'
        break;
    }

    var rentEndPeriodIndex = this.monthlyMarketDays.findIndex(
      e => e.RentalMonths == this.datePipe.transform(el.RentalEndDate, 'MMMM yyyy')
    );

    var renewalStartMonth = this.monthlyMarketDays[rentEndPeriodIndex + 1]?.RentalMonths;

    if (el.Status == "R") {
      if (initialStartDate <= today) {
        el.RentalStartDate = StartDateList[0].startDate;
        el.RentalEndDate = StartDateList[StartDateList.length - 1].startDate;
      }
      rentEndPeriodIndex = 0;
      renewalStartMonth = this.monthlyMarketDays[rentEndPeriodIndex]?.RentalMonths;

      var obj = {
        BoothTypeId: el.BoothTypeId,
        VendorId: this.vendorId,
        RentalStartPeriod: new Date(el.RentalStartDate),
        RentalEndPeriod: new Date(el.RentalEndDate),
        RentalMarketDay: marketDay
      };

      const res = await this.rentalService.getBoothRentalMontlyCharges(this.marketId, obj).toPromise();

      if (res) {
        const ob = {
          MonthlyRentalId: el.MonthlyRentalId,
          BoothNumber: el.BoothNumber,
          BoothType: el.BoothType,
          BoothTypeId: el.BoothTypeId,
          RentalStartDate: this.datePipe.transform(el.RentalStartDate, 'MMM d, y'),
          RentalEndDate: this.datePipe.transform(el.RentalEndDate, 'MMM d, y'),
          RentalSavedEndDate: this.datePipe.transform(el.RentalStartDate, 'MMM d, y'),
          RentStartPeriod: this.datePipe.transform(el.RentalStartDate, 'MMMM yyyy'),
          RentEndPeriod: this.datePipe.transform(el.RentalEndDate, 'MMMM yyyy'),
          Product: el.ProductId,
          ProductName: this.vendorProducts.filter(e => e.ProductId == el.ProductId)[0]?.ProductName,
          StartDateList: StartDateList,
          MktDays: marketDays,
          PerDiemRent: this.customCurrency.transform('0.00'),
          Rent: this.customCurrency.transform(res.Rent),
          SalesTax: this.customCurrency.transform(res.SalesTax),
          CityTax: this.customCurrency.transform(res.CityTax),
          CurrentRentStartPeriod: this.datePipe.transform(el.RentalStartDate, 'MMMM yyyy'),
          CurrentRentEndPeriod: this.datePipe.transform(el.RentalEndDate, 'MMMM yyyy'),
          CurrentRent: this.customCurrency.transform(el.RentalCharge),
          CurrentSalesTax: this.customCurrency.transform(el.SalesTax),
          CurrentSecondTax: this.customCurrency.transform(el.SecLevelTax),
          Sunday: el.Sunday,
          Monday: el.Monday,
          Tuesday: el.Tuesday,
          Wednesday: el.Wednesday,
          Thursday: el.Thursday,
          Friday: el.Friday,
          Saturday: el.Saturday,
          Reservation: el.BoothReserved,
          Drop: el.DoNotRenew,
          January: this.customCurrency.transform(res.JanRent),
          February: this.customCurrency.transform(res.FebRent),
          March: this.customCurrency.transform(res.MarRent),
          April: this.customCurrency.transform(res.AprRent),
          May: this.customCurrency.transform(res.MayRent),
          June: this.customCurrency.transform(res.JunRent),
          July: this.customCurrency.transform(res.JulRent),
          August: this.customCurrency.transform(res.AugRent),
          September: this.customCurrency.transform(res.SepRent),
          October: this.customCurrency.transform(res.OctRent),
          November: this.customCurrency.transform(res.NovRent),
          December: this.customCurrency.transform(res.DecRent),
          JanuaryMonthPresent: res.JanuaryMonthPresent,
          FebruaryMonthPresent: res.FebruaryMonthPresent,
          MarchMonthPresent: res.MarchMonthPresent,
          AprilMonthPresent: res.AprilMonthPresent,
          MayMonthPresent: res.MayMonthPresent,
          JuneMonthPresent: res.JuneMonthPresent,
          JulyMonthPresent: res.JulyMonthPresent,
          AugustMonthPresent: res.AugustMonthPresent,
          SeptemberMonthPresent: res.SeptemberMonthPresent,
          OctoberMonthPresent: res.OctoberMonthPresent,
          NovemberMonthPresent: res.NovemberMonthPresent,
          DecemberMonthPresent: res.DecemberMonthPresent,
          DisableJanMonth: res.JanRent ? false : true,
          DisableFebMonth: res.FebRent ? false : true,
          DisableMarMonth: res.MarRent ? false : true,
          DisableAprMonth: res.AprRent ? false : true,
          DisableMayMonth: res.MayRent ? false : true,
          DisableJunMonth: res.JunRent ? false : true,
          DisableJulMonth: res.JulRent ? false : true,
          DisableAugMonth: res.AugRent ? false : true,
          DisableSepMonth: res.SepRent ? false : true,
          DisableOctMonth: res.OctRent ? false : true,
          DisableNovMonth: res.NovRent ? false : true,
          DisableDecMonth: res.DecRent ? false : true,
          DiasbleStartDate: false,
          Status: el.Status,
          NewBooth: false,
          ExtendRental: true,
          BookingCanExtend: true,
          AllRentalDates: StartDateList.map(el => new Date(el.startDate)),
          RenewalStartMonth: renewalStartMonth,
          MonthlyRenewalMonth: this.monthlyMarketDays[rentEndPeriodIndex]?.RentalMonths,
          RentEndPeriodIndex: rentEndPeriodIndex
        };

        if (this.allowMonthlyRentalRenewal) {
          this.totalRentalCharge += this.getActualAmountFromInp(res.Rent);
          this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
          this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
          this.updateCharges();
        }
        this.selectedMonthlyBooths.push(ob);
      }
    } else {
      var rentalStartPeriod;
      if (this.MonthlyBookingEndDate && this.rentalType == 4) {
        let rentalStartDate = new Date(el.RentalStartDate);
        var startMonth = rentalStartDate.getMonth() + 1;
        var startYear = rentalStartDate.getFullYear();
        const startYearAndMonth = `${startYear}${startMonth < 10 ? '0' : ''}${startMonth}`;
        const rentalMonthEndDate = await this.getMonthEndingDateFromSetting(startYearAndMonth);

        if (new Date(el.RentalStartDate) > rentalMonthEndDate) {
          rentalStartDate = new Date(el.RentalStartDate);
          const dayOfMonth = rentalStartDate.getDate();
          rentalStartDate.setMonth(rentalStartDate.getMonth() + 1);

          if (rentalStartDate.getDate() < dayOfMonth) {
            rentalStartDate.setDate(0);
          }
          rentalStartPeriod = this.datePipe.transform(rentalStartDate, 'MMMM yyyy');
        } else {
          rentalStartPeriod = this.datePipe.transform(el.RentalStartDate, 'MMMM yyyy');
        }
      } else {
        rentalStartPeriod = this.datePipe.transform(el.RentalStartDate, 'MMMM yyyy');
      }

      const ob = {
        MonthlyRentalId: el.MonthlyRentalId,
        BoothNumber: el.BoothNumber,
        BoothType: el.BoothType,
        BoothTypeId: el.BoothTypeId,
        RentalStartDate: this.datePipe.transform(el.RentalStartDate, 'MMM d, y'),
        RentalEndDate: this.datePipe.transform(el.RentalEndDate, 'MMM d, y'),
        RentalSavedEndDate: this.datePipe.transform(el.RentalEndDate, 'MMM d, y'),
        RentStartPeriod: rentalStartPeriod,
        RentEndPeriod: this.datePipe.transform(el.RentalEndDate, 'MMMM yyyy'),
        Product: el.ProductId,
        ProductName: this.vendorProducts.filter(e => e.ProductId == el.ProductId)[0]?.ProductName,
        StartDateList: StartDateList,
        MktDays: marketDays,
        PerDiemRent: this.customCurrency.transform('0.00'),
        Rent: this.customCurrency.transform('0.00'),
        SalesTax: this.customCurrency.transform('0.00'),
        CityTax: this.customCurrency.transform('0.00'),
        CurrentRentStartPeriod: this.datePipe.transform(el.RentalStartDate, 'MMMM yyyy'),
        CurrentRentEndPeriod: this.datePipe.transform(el.RentalEndDate, 'MMMM yyyy'),
        CurrentRent: this.customCurrency.transform(el.RentalCharge),
        CurrentSalesTax: this.customCurrency.transform(el.SalesTax),
        CurrentSecondTax: this.customCurrency.transform(el.SecLevelTax),
        Sunday: el.Sunday,
        Monday: el.Monday,
        Tuesday: el.Tuesday,
        Wednesday: el.Wednesday,
        Thursday: el.Thursday,
        Friday: el.Friday,
        Saturday: el.Saturday,
        Reservation: el.BoothReserved,
        Drop: el.DoNotRenew,
        Status: el.Status,
        BookingCanExtend: true,
        January: this.customCurrency.transform('0.00'),
        February: this.customCurrency.transform('0.00'),
        March: this.customCurrency.transform('0.00'),
        April: this.customCurrency.transform('0.00'),
        May: this.customCurrency.transform('0.00'),
        June: this.customCurrency.transform('0.00'),
        July: this.customCurrency.transform('0.00'),
        August: this.customCurrency.transform('0.00'),
        September: this.customCurrency.transform('0.00'),
        October: this.customCurrency.transform('0.00'),
        November: this.customCurrency.transform('0.00'),
        December: this.customCurrency.transform('0.00'),
        JanuaryMonthPresent: el.JanuaryMonthPresent,
        FebruaryMonthPresent: el.FebruaryMonthPresent,
        MarchMonthPresent: el.MarchMonthPresent,
        AprilMonthPresent: el.AprilMonthPresent,
        MayMonthPresent: el.MayMonthPresent,
        JuneMonthPresent: el.JuneMonthPresent,
        JulyMonthPresent: el.JulyMonthPresent,
        AugustMonthPresent: el.AugustMonthPresent,
        SeptemberMonthPresent: el.SeptemberMonthPresent,
        OctoberMonthPresent: el.OctoberMonthPresent,
        NovemberMonthPresent: el.NovemberMonthPresent,
        DecemberMonthPresent: el.DecemberMonthPresent,
        DisableJanMonth: true,
        DisableFebMonth: true,
        DisableMarMonth: true,
        DisableAprMonth: true,
        DisableMayMonth: true,
        DisableJunMonth: true,
        DisableJulMonth: true,
        DisableAugMonth: true,
        DisableSepMonth: true,
        DisableOctMonth: true,
        DisableNovMonth: true,
        DisableDecMonth: true,
        DiasbleStartDate: true,
        NewBooth: false,
        AllRentalDates: StartDateList.map(el => new Date(el.startDate)),
        RenewalStartMonth: renewalStartMonth,
        MonthlyRenewalMonth: this.monthlyMarketDays[rentEndPeriodIndex + 1]?.RentalMonths,
        RentEndPeriodIndex: rentEndPeriodIndex
      };
      this.selectedMonthlyBooths.push(ob);
    }
  }

  getDaysDifference(date1: Date, date2: Date): number {
    // Normalize both dates to start of the day (midnight)
    const start = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const end = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
    // Calculate the difference in time (milliseconds)
    const timeDiff = Math.abs(end.getTime() - start.getTime());
    // Convert time difference from milliseconds to days
    const dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return dayDiff;
  }

  async handleMonthlyEndDateChange(): Promise<void> {
    this.renewAllBoothsFromGrid = false;

    if (this.selectedMonthlyBooths.length === 0) {
      await this.renewAllBooths();
      return;
    }

    this.renewAllBoothsFromGrid = true;

    if (!((this.ResaleNumberRequired && !this.exemptResale) || this.BusinessLicenseNumberRequired)) {
      await this.renewAllBooths();
      return;
    }

    const rentalDates: any[] = [];
    this.vendorRentalDays = [];
    this.marketDayCountForResale = 0;

    // Request the vendor's rental days up front so it runs alongside the date calculation below.
    const vendorRentalDaysRequest = this.getVendorRentalDays();
    vendorRentalDaysRequest.catch(() => { }); // only awaited (and surfaced) when needed

    await this.processSelectedBooths(rentalDates);

    await Promise.all(
      this.selectedMonthlyBooths
        .filter(item => this.shouldProcessBooth(item))
        .map(item => this.processBoothRentalDates(item, rentalDates))
    );

    this.updateVendorRentalDays(rentalDates);

    if (this.marketDayCountForResale <= this.DaysSellWithoutResaleNumber ||
      this.marketDayCountForResale <= this.DaysSellWithoutBusiLicNumber) {
      const vendorRentalDaysRes = await vendorRentalDaysRequest;
      this.addVendorRentalDays(vendorRentalDaysRes);
    }

    await this.checkResaleOrBusinessLicense(true);
  }

  updateMonthlytherItemRecord(record, monthlyRenewalMonth = ""){
    if (record.Recurring) {
      var rentEndPeriodIndex = 0;
      if (record.Status != "R") {
        rentEndPeriodIndex = this.monthlyMarketDays.findIndex(e => e.RentalMonths == record.RentalMonth);
      }
      var renewalStartMonth = this.monthlyMarketDays[rentEndPeriodIndex + 1].RentalMonths;
      record.BookingCanExtend = true;
      record.Quantity = 1;
      record.RentalMonth = record.CurrentRentalMonth;
      if (record.Status == "R") {
        renewalStartMonth = this.monthlyMarketDays[rentEndPeriodIndex].RentalMonths;
        record.RentalMonth = this.monthlyMarketDays[rentEndPeriodIndex].RentalMonths;
      }
      record.RenewalStartMonth = renewalStartMonth;
      record.MonthlyRenewalMonth = renewalStartMonth;
      record.RentEndPeriodIndex = rentEndPeriodIndex
      if (monthlyRenewalMonth != "") {
        record.MonthlyRenewalMonth = monthlyRenewalMonth;
      }
      this.extendMonthlyOtherRental(record);
      this.applyOnlineBookingFeeIfNeeded();
    }
    else {
      if (this.preventVendorUncheckOtherItemRenewal && !record.Recurring) {
        setTimeout(() => record.Recurring = true);
        return;
      }
      record.BookingCanExtend = false;
      record.RenewalStartWeek = "This booking cannot be extended further!";
      record.MonthlyRenewalMonth = record.RentalMonth;
      this.totalOtherRentalCharge -= this.getActualAmountFromInp(record.OtherItemtotal);
      this.totalSalesTax -= this.getActualAmountFromInp(record.SalesTax);
      this.totalSecondLeveltax -= this.getActualAmountFromInp(record.CityTax);
      this.updateCharges();
      record.OtherItemtotal = this.customCurrency.transform("0");
      record.Quantity = 0;
      record.OtherItemCharge = this.customCurrency.transform("0");
      this.applyOnlineBookingFeeIfNeeded();
    }
  }

  isAnyRenewalSelected(): boolean {
    const monthlyRenewal = this.selectedMonthlyBooths?.some(b => b.Reservation) ?? false;
    const weeklyRenewal = this.selectedWeeklyBooths?.some(b => b.Reservation) ?? false;
    //const otherItemRenewal = this.selectedOtherItems?.some(o => o.Recurring) ?? false;
    return monthlyRenewal || weeklyRenewal;
  }

  applyOnlineBookingFeeIfNeeded() {
    if (!this.allowRenewalsFee || !this.allowRenewalsFeeId) {
      return;
    }
    const anyRenewal = this.isAnyRenewalSelected();
    if (anyRenewal !== this.onlineBookingFeeApplied) {
      this.onlineBookingFeeApplied = anyRenewal;
      this.calculateBalance();
    }
  }

  updateCharges() {
    this.applyOnlineBookingFeeIfNeeded();
    this.totalCharge = this.priorBalance + this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;
    this.bookingDetailsForm.patchValue({
      rentalCharge: this.customCurrency.transform(this.totalRentalCharge.toString()),
      otherCharge: this.customCurrency.transform(this.totalOtherRentalCharge.toString()),
      totalSalesTax: this.customCurrency.transform(this.totalSalesTax.toString()),
      totalSecondLeveltax: this.customCurrency.transform(this.totalSecondLeveltax.toString()),
      totalCharge: this.customCurrency.transform(this.totalCharge.toString())
    });
  }

  async extendMonthlyOtherRental(item: any) {
    this.loaderIcon = Promise.resolve(true);
    const currentMonth = new Date(item.RenewalStartMonth);

    if (currentMonth > new Date(item.MonthlyRenewalMonth) || !item.Recurring || !this.allowOtherItemRenewal) {
      item.BookingCanExtend = false;
      item.RenewalStartMonth = "This booking cannot be extended further!";
      item.MonthlyRenewalMonth = item.RentalMonth;
      this.loaderIcon = Promise.resolve(false);
      return;
    }

    this.totalOtherRentalCharge -= this.getActualAmountFromInp(item.OtherItemtotal);
    this.totalSalesTax -= this.getActualAmountFromInp(item.SalesTax);
    this.totalSecondLeveltax -= this.getActualAmountFromInp(item.CityTax);
    this.updateCharges();
    item.OtherItemtotal = this.customCurrency.transform("0");
    await this.getOtherRentalItems();


    const monthsToProcess: { rentalStartMonth: string; otherItemCharge: string }[] = [];
    // Defensive: ensure dates are valid
    const renewalEnd = item.MonthlyRenewalMonth ? new Date(item.MonthlyRenewalMonth) : null;
    if (!renewalEnd || isNaN(renewalEnd.getTime())) {
      console.error('Invalid MonthlyRenewalMonth:', item.MonthlyRenewalMonth);
      this.loaderIcon = Promise.resolve(false);
      return;
    }

    const tempMonth = new Date(currentMonth);

    // Helper for robust composite key
    const makeCompositeKey = (obj: any) => [
      obj.RentalMonth,
      obj.Id,
      obj.Reference,
      encodeURIComponent(obj.BoothNo || obj.BoothNumber || "")
    ].join('|');

    // Defensive: YearMonth validation helper
    const isValidYearMonth = (val: string) => {
      // Accepts YYYY-MM or MM/YYYY or similar
      return val && /^(\d{4}-\d{2}|\d{2}\/\d{4})$/.test(val.trim());
    };

    while (tempMonth <= renewalEnd) {

      const formatted = this.datePipe.transform(new Date(tempMonth), 'MM/dd/yyyy');
      tempMonth.setMonth(tempMonth.getMonth() + 1);
      const rentalMonthDate = this.monthlyMarketDays.find(date =>
        this.datePipe.transform(new Date(date.RentalMonths), 'MM/dd/yyyy') === formatted
      );
      if (!rentalMonthDate) continue;

      const rentalStartMonth = rentalMonthDate.RentalMonths;
      // Defensive: skip if rentalStartMonth is falsy
      if (!rentalStartMonth) continue;

      // Use robust composite key for deduplication
      const recordExist = this.selectedOtherItems.findIndex(e =>
        makeCompositeKey(e) === makeCompositeKey({
          RentalMonth: rentalStartMonth,
          Id: item.Id,
          Reference: item.Reference,
          BoothNo: item.BoothNo
        })
      );

      let otherItemCharge = this.resolveRenewalCharge(item);
      if (!otherItemCharge) {
        console.warn('[OtherCharges] no charge found for', item.OtherItem, rentalStartMonth);
        continue;
      }

      let chargeResolved = true;
      if (this.OtherChargesPeriod) {
        const date = new Date(`${rentalStartMonth} 1`);
        const formattedDate = this.datePipe.transform(`${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`, 'MM/dd/yyyy');
        const companyOtherRentalId = this.otherItemList.find(e => e.OtherItem == item.OtherItem)?.CompanyOtherRentalId;
        if (companyOtherRentalId != null) {
          try {
            const response = await this.rentalService.getOtherRentalItems(this.marketId, formattedDate).toPromise();
            if (response) {
              const matchedItem = response.find(e => e.OtherItemCompanyId == companyOtherRentalId);
              if (matchedItem) {
                otherItemCharge = this.customCurrency.transform(matchedItem.OtherItemMonthlyCharge);
              } else {
                console.warn('No matching other rental item found for companyOtherRentalId:', companyOtherRentalId);
                chargeResolved = false;
              }
            }
          } catch (err) {
            console.error('Error fetching other rental items for period:', err);
            chargeResolved = false;
          }
        }
      }

      // Fallback logic: if chargeResolved is false, use original charge and log
      if (!chargeResolved) {
        console.warn(`Falling back to original charge for month ${rentalStartMonth}, item ${item.Id}`);
        // Already set above from otherItemList/allrentedOtherItems
      }
      monthsToProcess.push({ rentalStartMonth, otherItemCharge });
    }

    if (monthsToProcess.length === 0) {
      this.loaderIcon = Promise.resolve(false);
      return;
    }

    const requests = monthsToProcess.map(({ otherItemCharge }) => {
      const isNegative = otherItemCharge.includes('(') && otherItemCharge.includes(')');
      const rawCharge = parseFloat(otherItemCharge.replace(/[^0-9.-]/g, ''));
      const finalCharge = isNegative ? -rawCharge : rawCharge;

      return {
        obj: {
          MarketId: this.marketId,
          OtherItemId: item.Id,
          VendorId: this.vendorId,
          Quantity: item.Quantity,
          OtherItemCharge: finalCharge
        },
        finalCharge,
        otherItemCharge
      };
    });

    const results = await Promise.all(
      requests.map(({ obj }) =>
        lastValueFrom(this.rentalService.getOtherItemsRentalCharges(obj)).catch(err => {
          console.error('[OtherCharges] tax lookup failed, applying charge without tax', item.OtherItem, err);
          return { SalesTax: 0, CityTax: 0 };
        })
      )
    );

    let totalCharge = 0;
    let totalSalesTax = 0;
    let totalCityTax = 0;

    results.forEach((res: any, index) => {
      const { finalCharge, otherItemCharge } = requests[index];

      item.OtherItemCharge = this.customCurrency.transform(finalCharge.toString());
      item.OtherItemtotal = this.customCurrency.transform(
        (parseFloat(item.OtherItemtotal.replace(/[^0-9.-]/g, '')) + (finalCharge * item.Quantity)).toString()
      );
      item.MonthlyRentalIds += ',' + item.Id;
      item.MonthlyRenewalMonth = item.MonthlyRenewalMonth;

      totalCharge += this.getActualAmountFromInp(item.OtherItemCharge);
      totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
      totalCityTax += this.getActualAmountFromInp(res.CityTax);
      this.loaderIcon = Promise.resolve(false);
    });

    this.totalOtherRentalCharge += totalCharge;
    this.totalSalesTax += totalSalesTax;
    this.totalSecondLeveltax += totalCityTax;
    this.updateCharges();
  }

  getDateFromDateTime(date){
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  renewMonthlyOtherCharges() {
    if (this.selectedOtherItems.length > 0) {
      this.proceedRenewingOtherCharges();
    }
  }

  async proceedRenewingOtherCharges() {
    await this.getOtherRentalItems();
    for (const item of this.selectedOtherItems) {
     try {
      const endMonth = new Date(item.MonthlyRenewalMonth);
      const currentMonth = new Date(item.RentalMonth);
      if (item.Status != "R") {
        if (this.getDateFromDateTime(currentMonth) <= this.getDateFromDateTime(new Date(item.MonthlyRenewalMonth)) && item.Recurring && this.allowOtherItemRenewal) {
          var nextDate = currentMonth.setMonth(currentMonth.getMonth() + 1);
          var rentalMonthDate = this.monthlyMarketDays.filter(date => this.datePipe.transform(new Date(date.RentalMonths), 'MM/dd/yyyy') <= this.datePipe.transform(new Date(nextDate), 'MM/dd/yyyy')
            && this.datePipe.transform(new Date(date.RentalMonths), 'MM/dd/yyyy') >= this.datePipe.transform(new Date(nextDate), 'MM/dd/yyyy'))
          if (rentalMonthDate.length > 0)
            var rentalEndMonth = rentalMonthDate[0].RentalMonths;
          var recordExist = this.selectedOtherItems.findIndex(e => e.RentalMonth == rentalEndMonth && e.Id == item.Id && e.Reference == item.Reference && e.BoothNo == item.BoothNo)
          if (recordExist == -1) {
            var otherItemCharge = this.resolveRenewalCharge(item);
            if (!otherItemCharge) {
              console.warn('[OtherCharges] no charge found, skipping', item.OtherItem);
              continue;
            }

            let periodChargeResolved = true;
            if (this.OtherChargesPeriod) {
              const date = new Date(`${rentalEndMonth} 1`);
              const formattedDate = this.datePipe.transform(`${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`, 'MM/dd/yyyy');
              const companyOtherRentalId = this.otherItemList.find(e => e.OtherItem == item.OtherItem)?.CompanyOtherRentalId;
              if (companyOtherRentalId != null) {
                try {
                  const response = await this.rentalService.getOtherRentalItems(this.marketId, formattedDate).toPromise();
                  if (response) {
                    const matchedItem = response.find(e => e.OtherItemCompanyId == companyOtherRentalId);
                    if (matchedItem) {
                      otherItemCharge = this.customCurrency.transform(matchedItem.OtherItemMonthlyCharge);
                    } else {
                      console.warn('No matching other rental item found for companyOtherRentalId:', companyOtherRentalId);
                      periodChargeResolved = false;
                    }
                  }
                } catch (err) {
                  console.error('Error fetching other rental items for period:', err);
                  periodChargeResolved = false;
                }
              }
            }
            if (!periodChargeResolved) continue;

            var obj = {
              MarketId: this.marketId,
              OtherItemId: item.Id,
              VendorId: this.vendorId,
              Quantity: item.Quantity,
              OtherItemCharge: this.getActualAmountFromInp(otherItemCharge)
            }

            var res: any = null;
            try {
              res = await this.rentalService.getOtherItemsRentalCharges(obj).toPromise();
            } catch (err) {
              console.error('[OtherCharges] tax lookup failed, applying charge without tax', item.OtherItem, err);
            }
            const isNegative = otherItemCharge.includes('(') && otherItemCharge.includes(')');
            const totalValue = parseFloat(otherItemCharge.replace(/[^0-9.-]/g, ''));
            const finalCharge = isNegative ? -totalValue : totalValue;
            const OtherItemtotal = this.customCurrency.transform((finalCharge * item.Quantity).toString());
            item.Quantity = item.Quantity;
            item.MonthlyRentalIds += ',' + item.Id
            item.OtherItemCharge = otherItemCharge
            item.OtherItemtotal = OtherItemtotal;
            item.MonthlyRenewalMonth = rentalEndMonth;

            this.totalOtherRentalCharge += this.getActualAmountFromInp(item.OtherItemtotal);
            this.totalSalesTax += this.getActualAmountFromInp(res?.SalesTax ?? 0);
            this.totalSecondLeveltax += this.getActualAmountFromInp(res?.CityTax ?? 0);
            this.updateCharges();
          }
        }
        else {
          item.BookingCanExtend = false;
          item.RenewalStartMonth = "This booking cannot be extended further!";
          item.MonthlyRenewalMonth = item.RentalMonth;
        }
      }
     } catch (err) {
       console.error('[OtherCharges] failed to price renewal for', item?.OtherItem, err);
     }
    }
  }
  // Helper functions

  // Process selected booths for rental dates
  async processSelectedBooths(rentalDates: any[]) {
    const selectedBoothRecord = this.selectedMonthlyBooths.filter(e => e.NewBooth || e.ExtendRental);
    for (const record of selectedBoothRecord) {
      for (const el of this.getBoothMarketDays(record)) {
        this.addRentalDates(record, rentalDates, el - 1);
      }
    }
  }

  // Market days a booth is rented on (1 = Sun ... 7 = Sat, same encoding as selectedMarketDays).
  // selectedMarketDays only holds the last booth processed by renewAllBooths (empty on page load),
  // so the resale/business license day count must use each booth's own days.
  private getBoothMarketDays(booth: any): number[] {
    return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      .map((day, index) => booth[day] ? index + 1 : 0)
      .filter(day => day > 0);
  }

  // Check if the booth should be processed
  shouldProcessBooth(item: any): boolean {
    return new Date(item.RentEndPeriod.split('-')[0]) < new Date(item.MonthlyRenewalMonth) &&
      !item.Drop && item.Reservation;
  }

  // Process rental dates for a booth
  async processBoothRentalDates(item: any, rentalDates: any[]) {
    const recordExist = this.selectedMonthlyBooths.findIndex(e =>
      e.RentStartPeriod === item.RentStartPeriod && e.RentEndPeriod === item.RentEndPeriod &&
      e.BoothNumber === item.BoothNumber && (item.MonthlyRentalId === 0 || e.MonthlyRentalId === item.MonthlyRentalId)
    );

    if (recordExist !== -1) {
      const startDate = new Date(this.selectedMonthlyBooths[recordExist].RentalStartDate);
      let endDate = await this.calculateEndDate(item);

      // Loop through the booth's market days and add dates
      this.getBoothMarketDays(this.selectedMonthlyBooths[recordExist]).forEach((el) => {
        this.addRentalDates({ RentalStartDate: startDate, RentalEndDate: endDate }, rentalDates, el - 1);
      });
    }
  }

  // Add rental dates based on the day of the week
  addRentalDates(record: any, rentalDates: any[], dayOfWeek: number) {
    let currentDay = new Date(record.RentalStartDate);
    const endDate = new Date(record.RentalEndDate);

    while (currentDay <= endDate) {
      if (currentDay.getDay() === dayOfWeek) {
        rentalDates.push({ startDate: this.datePipe.transform(currentDay, 'MMM d, y') });
      }
      currentDay.setDate(currentDay.getDate() + 1);
    }
  }

  // Calculate end date based on MonthlyRenewalMonth
  async calculateEndDate(item: any): Promise<Date> {
    const [endMonthDate, endMonthYear] = item.MonthlyRenewalMonth.split(' ');
    const endMonthIndex = this.getMonthIndex(endMonthDate);
    let endDate = new Date(endMonthYear, endMonthIndex + 1, 0);

    if (this.MonthlyBookingEndDate) {
      const rentalEndDateYearMonth = `${endDate.getFullYear()}${(endDate.getMonth() + 1).toString().padStart(2, '0')}`;
      endDate = await this.getMonthEndingDateFromSetting(rentalEndDateYearMonth);
    }

    return endDate;
  }

  // Update vendor rental days by comparing with existing rental dates
  updateVendorRentalDays(rentalDates: any[]) {
    // Set lookup instead of re-formatting every existing day for each date (was O(n²) date formatting)
    const existingDays = this.getVendorRentalDaySet();
    rentalDates.forEach(date => {
      const targetDateString = this.datePipe.transform(date.startDate, "MM/dd/yyyy");
      if (!existingDays.has(targetDateString)) {
        existingDays.add(targetDateString);
        this.vendorRentalDays.push({ VendorRentalDate: targetDateString });
        this.marketDayCountForResale += 1;
      }
    });
  }

  // The vendor's already-saved rental days don't change while this page is open, so they are
  // fetched once and reused by every resale/business license check (page load and each extend).
  private vendorRentalDaysRequest: Promise<any[]> = null;

  private getVendorRentalDays(): Promise<any[]> {
    if (!this.vendorRentalDaysRequest) {
      this.vendorRentalDaysRequest = this.rentalService.getVendorRentalDays(
        { VendorID: this.vendorId, VendorRentalDate: new Date() }
      ).toPromise();
      // Do not keep a failed request; the next check retries.
      this.vendorRentalDaysRequest.catch(() => this.vendorRentalDaysRequest = null);
    }
    return this.vendorRentalDaysRequest;
  }

  private getVendorRentalDaySet(): Set<string> {
    return new Set(this.vendorRentalDays.map(el => this.datePipe.transform(el.VendorRentalDate, "MM/dd/yyyy")));
  }

  getActualAmountFromInp(value) {
    var amount = value.toString().includes('(') && value.toString().includes(')') ? -1 * parseFloat(value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(value.toString().replace(/[^0-9.-]/g, ''));
    return amount;
  }

  disableSavePayment() {
    var proceedPayment = false;
    this.paymentAdjustedWithPriorBal = false;
    const rentalCharge = this.getActualAmountFromInp(this.bookingDetailsForm.get('rentalCharge').value)
    const otherCharge = this.getActualAmountFromInp(this.bookingDetailsForm.get('otherCharge').value)
    const salesTax = this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSalesTax').value)
    const secondTax = this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSecondLeveltax').value)
    const additionalCharge = this.getActualAmountFromInp(this.bookingDetailsForm.get('additionalCharge').value)
    const priorBalance = this.getActualAmountFromInp(this.bookingDetailsForm.get('priorBalance').value)
    var totalCharges = rentalCharge + otherCharge + salesTax + secondTax + additionalCharge;
    if(priorBalance < 0 && totalCharges > 0 && (totalCharges + priorBalance <= 0)){
      proceedPayment = true;
      this.paymentAdjustedWithPriorBal = true;
    }
    const paymentAmount = this.getActualAmountFromInp(this.bookingDetailsForm.get('totalPayment').value);
    if (paymentAmount > 0 || proceedPayment) {
      return false
    }
    else
      return true
  }

  // Add vendor rental days from API response
  addVendorRentalDays(res: any[]) {
    const existingDays = this.getVendorRentalDaySet();
    res.forEach(el => {
      const targetDateString = this.datePipe.transform(el.VendorRentalDate, "MM/dd/yyyy");
      if (!existingDays.has(targetDateString)) {
        existingDays.add(targetDateString);
        this.vendorRentalDays.push({ VendorRentalDate: targetDateString });
        this.marketDayCountForResale += 1;
      }
    });
  }

  // Check conditions for resale or business license
  async checkResaleOrBusinessLicense(noResale: boolean) {
    if (this.ResaleNumberRequired && !this.exemptResale && !this.resaleNo &&
      this.marketDayCountForResale > this.DaysSellWithoutResaleNumber && !this.resaleOptionSelected) {
      this.resaleModalFlow = {
        resume: () => this.checkResaleOrBusinessLicense(noResale),
        cancel: () => this.revertPendingMonthlyExtensions()
      };
      const modal = this.modalResaleNo.nativeElement;
      modal.classList.add('show');
      modal.style.display = 'block';
      noResale = false;
    } else if (this.BusinessLicenseNumberRequired &&
      this.marketDayCountForResale > this.DaysSellWithoutBusiLicNumber) {
      await this.handleBusinessLicenseNumber();
    } else {
      await this.renewAllBooths();
    }
  }

  // Handle business license number validation
  async handleBusinessLicenseNumber() {
    if (!this.businessLicenseNumber) {
      this.loaderIcon = Promise.resolve(false);
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Business License is required! Please contact the market`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
      this.revertPendingMonthlyExtensions();
      return;
    } else {
      await this.checkBusinessLicenseExpiry();
    }
  }

  // Check business license expiry date
  async checkBusinessLicenseExpiry() {
    if (!this.businessLicenseExpiryDate) {
      this.loaderIcon = Promise.resolve(false);
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Business License is expired! Please contact the market`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
      this.revertPendingMonthlyExtensions();
      return;
    }

    if (new Date(this.businessLicenseExpiryDate) < new Date()) {
      this.loaderIcon = Promise.resolve(false);
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Business License is expired! Please contact the market`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
      this.revertPendingMonthlyExtensions();
      return;
    } else {
      await this.renewAllBooths();
    }
  }

  // Undo pending renewals for every CM (Monthly) booth marked for renewal,
  // used when the "renew all" bulk flow is blocked before a specific record
  // is selected (no single extendRentalRecord to target).
  private revertPendingMonthlyExtensions() {
    this.selectedMonthlyBooths
      .filter(record => record.Reservation)
      .forEach(record => {
        record.Reservation = false;
        this.updateRentalRecord(record);
      });
  }

  async getMonthEndingDateFromSetting(rentalYearMonth: string): Promise<Date> {
    if (this.monthEndDateCache.has(rentalYearMonth)) {
      return this.monthEndDateCache.get(rentalYearMonth);
    }
    // Booths are processed in parallel; share one in-flight request per month instead of one per booth.
    let request = this.monthEndDateRequests.get(rentalYearMonth);
    if (!request) {
      request = this.rentalService.GetSelectedMonthEndDate(rentalYearMonth, this.marketId).toPromise()
        .then((response: any) => {
          this.monthEndDateRequests.delete(rentalYearMonth);
          if (response) {
            const monthEndDate = new Date(response.MonthEndDateSelected);
            this.monthEndDateCache.set(rentalYearMonth, monthEndDate);
            return monthEndDate;
          }
          return null;
        }, err => {
          this.monthEndDateRequests.delete(rentalYearMonth);
          throw err;
        });
      this.monthEndDateRequests.set(rentalYearMonth, request);
    }
    return request;
  }

  async renewAllBooths(): Promise<void> {
    const nonAvailableBooths: string[] = [];
    // Availability checks are started per booth and awaited together after the loop (instead of one
    // request at a time); results are applied in the original booth order so totals are unchanged.
    const pendingRenewals: { recordExist: number; rentalDates: any[]; marketDays: number; BoothNumber: string; rentalExist: Promise<any> }[] = [];

    for (const item of this.selectedMonthlyBooths) {
      if (item.Status === 'R') continue;

      const { RentEndPeriod, MonthlyRenewalMonth, Drop, Reservation, MonthlyRentalId, BoothNumber, RentStartPeriod } = item;
      const rentEndDate = new Date(RentEndPeriod.split('-')[0]);

      if (!(rentEndDate < new Date(MonthlyRenewalMonth) && !Drop && Reservation && this.allowMonthlyRentalRenewal)) {
        item.MonthlyRenewalMonth = item.RentEndPeriod;
        item.RenewalStartMonth = 'This booking cannot be extended further!';
        item.BookingCanExtend = false;
        nonAvailableBooths.push(item.BoothNumber);
        continue;
      }

      const recordExist = this.selectedMonthlyBooths.findIndex(e =>
        e.RentStartPeriod === RentStartPeriod &&
        e.RentEndPeriod === RentEndPeriod &&
        e.BoothNumber === BoothNumber &&
        e.MonthlyRentalId === MonthlyRentalId &&
        e.Reservation && !e.Drop
      );
      if (recordExist === -1) continue;

      const booth = this.selectedMonthlyBooths[recordExist];
      const rentalDates: any[] = [];
      let currentMonthRentalDates: any[] = [];
      let rentalstartDate = '';
      let marketDays = 0;

      this.selectedMarketDays = [];
      if (booth.Sunday)    this.selectedMarketDays.push(1);
      if (booth.Monday)    this.selectedMarketDays.push(2);
      if (booth.Tuesday)   this.selectedMarketDays.push(3);
      if (booth.Wednesday) this.selectedMarketDays.push(4);
      if (booth.Thursday)  this.selectedMarketDays.push(5);
      if (booth.Friday)    this.selectedMarketDays.push(6);
      if (booth.Saturday)  this.selectedMarketDays.push(7);

      // Compute endDate and currentMonthEnd once per booth — they don't vary per market day
      const [endMonthName, endMonthYear] = MonthlyRenewalMonth.split(' ');
      let endDate = new Date(+endMonthYear, this.getMonthIndex(endMonthName) + 1, 0);
      let endDateYearMonth: string;
      let currentMonthEnd: Date;

      if (this.MonthlyBookingEndDate) {
        const ey = endDate.getFullYear(), em = endDate.getMonth() + 1;
        endDateYearMonth = `${ey}${em < 10 ? '0' : ''}${em}`;
        endDate = await this.getMonthEndingDateFromSetting(endDateYearMonth);

        const [startMonthName, startMonthYear] = booth.RentStartPeriod.split(' ');
        currentMonthEnd = new Date(+startMonthYear, this.getMonthIndex(startMonthName) + 1, 0);
        const cy = currentMonthEnd.getFullYear(), cm = currentMonthEnd.getMonth() + 1;
        const currentStartYearMonth = `${cy}${cm < 10 ? '0' : ''}${cm}`;
        if (endDateYearMonth === currentStartYearMonth) {
          currentMonthEnd = await this.getMonthEndingDateFromSetting(currentStartYearMonth);
        }
      }

      for (const el of this.selectedMarketDays) {
        let startDate = new Date(booth.RentalStartDate);
        const selectedDayOfWeek = el - 1;

        if (this.MonthlyBookingEndDate) {
          const rentalStartDate = new Date(startDate);
          const previousMonth = new Date(rentalStartDate.setMonth(rentalStartDate.getMonth() - 1)).getMonth() + 1;
          const PreviousMonthYear = new Date(rentalStartDate.setMonth(rentalStartDate.getMonth() - 1)).getFullYear();
          const PreviousMonthYearAndMonth = `${PreviousMonthYear}${previousMonth < 10 ? '0' : ''}${previousMonth}`;
          const monthEndDate = await this.getMonthEndingDateFromSetting(PreviousMonthYearAndMonth);
          const dateDiff = this.getDaysDifference(monthEndDate, new Date(startDate));
          if (dateDiff <= 7 && new Date(monthEndDate) < startDate) {
            startDate = new Date() > new Date(monthEndDate)
              ? new Date()
              : new Date(monthEndDate.setDate(monthEndDate.getDate() + 1));
          }
        }

        let currentDay = new Date(startDate);
        while (currentDay <= endDate) {
          if (currentDay.getDay() === selectedDayOfWeek) {
            if (!rentalstartDate) rentalstartDate = this.datePipe.transform(currentDay, 'MMM d, y');
            marketDays++;
            rentalDates.push({ startDate: this.datePipe.transform(currentDay, 'MMM d, y') });
          }
          currentDay.setDate(currentDay.getDate() + 1);
        }

        if (this.MonthlyBookingEndDate) {
          currentDay = new Date(startDate);
          while (currentDay <= currentMonthEnd) {
            if (currentDay.getDay() === selectedDayOfWeek) {
              if (!rentalstartDate) rentalstartDate = this.datePipe.transform(currentDay, 'MMM d, y');
              currentMonthRentalDates.push({ startDate: this.datePipe.transform(currentDay, 'MMM d, y') });
            }
            currentDay.setDate(currentDay.getDate() + 1);
          }
        }
      }

      this.sortDates(rentalDates);
      if (this.MonthlyBookingEndDate) this.sortDates(currentMonthRentalDates);
      else currentMonthRentalDates = rentalDates;

      const currentRentedEndDate = new Date(booth.RentalEndDate);
      const filteredRentalDates = rentalDates.map(d => new Date(d.startDate)).filter(d => d > currentRentedEndDate);

      const rentalExist = this.rentalService.checkRentalExits(this.marketId, {
        RentalDates: filteredRentalDates,
        BoothNumber: booth.BoothNumber
      }).toPromise();
      rentalExist.catch(() => { }); // surfaced by Promise.all below
      pendingRenewals.push({ recordExist, rentalDates, marketDays, BoothNumber, rentalExist });
    }

    const rentalExistResults = await Promise.all(pendingRenewals.map(p => p.rentalExist));
    const availableRenewals = pendingRenewals.filter((p, i) => {
      if (rentalExistResults[i].Success) {
        nonAvailableBooths.push(p.BoothNumber);
        return false;
      }
      return true;
    });

    const charges = await Promise.all(availableRenewals.map(p => this.getBoothRentCharges(p.recordExist, p.rentalDates)));
    availableRenewals.forEach((p, i) => this.applyBoothRentDetails(p.recordExist, p.rentalDates, p.marketDays, charges[i]));
  }

  private async getEndDate(MonthlyRenewalMonth, startDate: Date) {
    const [endMonthDate, endMonthYear] = MonthlyRenewalMonth.split(' ');
    const endMonthIndex = this.getMonthIndex(endMonthDate);
    return new Date(endMonthYear, endMonthIndex + 1, 0);
  }

  private async getPreviousMonthEndDate(startDate: Date) {
    const rentalStartDate = new Date(startDate);
    rentalStartDate.setMonth(rentalStartDate.getMonth() - 1);
    const previousMonth = rentalStartDate.getMonth() + 1;
    const previousYear = rentalStartDate.getFullYear();
    return await this.getMonthEndingDateFromSetting(`${previousYear}${previousMonth.toString().padStart(2, '0')}`);
  }

  private filterCurrentMonthDates(startDate: Date, selectedDayOfWeek: number, currentMonthRentalDates: any[]) {
    let currentDay = new Date(startDate);
    const currentMonthEnd = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
    while (currentDay <= currentMonthEnd) {
      if (currentDay.getDay() === selectedDayOfWeek) {
        currentMonthRentalDates.push({ startDate: this.datePipe.transform(new Date(currentDay), 'MMM d, y') });
      }
      currentDay.setDate(currentDay.getDate() + 1);
    }
    return currentMonthRentalDates;
  }

  private sortDates(dates: any[]): any[] {
    return dates.sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime());
  }

  private filterDatesAfterEndDate(allRentalDates: Date[], currentRentedEndDate: string): Date[] {
    const currentEndDate = new Date(currentRentedEndDate);
    return allRentalDates.filter(date => date > currentEndDate);
  }

  private getBoothRentCharges(recordExist: number, rentalDates: any[]): Promise<any> {
    const { BoothTypeId, RenewalStartMonth, Status, PerDiem, Rent, SalesTax, CityTax } = this.selectedMonthlyBooths[recordExist];
    var marketDay;
    if (this.selectedMonthlyBooths[recordExist].Sunday == true) {
      marketDay = 'Sun'
    }
    else if (this.selectedMonthlyBooths[recordExist].Monday == true) {
      marketDay = 'Mon'
    }
    else if (this.selectedMonthlyBooths[recordExist].Tuesday == true) {
      marketDay = 'Tue'
    }
    else if (this.selectedMonthlyBooths[recordExist].Wednesday == true) {
      marketDay = 'Wed'
    }
    else if (this.selectedMonthlyBooths[recordExist].Thursday == true) {
      marketDay = 'Thu'
    }
    else if (this.selectedMonthlyBooths[recordExist].Friday == true) {
      marketDay = 'Fri'
    }
    else if (this.selectedMonthlyBooths[recordExist].Saturday == true) {
      marketDay = 'Sat'
    }

    return this.rentalService.getBoothRentalMontlyCharges(this.marketId, {
      BoothTypeId,
      VendorId: this.vendorId,
      RentalStartPeriod: new Date(RenewalStartMonth),
      RentalEndPeriod: new Date(rentalDates[rentalDates.length - 1].startDate),
      PerDiemApplicable: PerDiem,
      RentalMarketDay: marketDay,
      Rent: this.getActualAmountFromInp(Rent),
      SalesTax: this.getActualAmountFromInp(SalesTax),
      CityTax: this.getActualAmountFromInp(CityTax)
    }).toPromise();
  }

  private applyBoothRentDetails(recordExist: number, rentalDates: any[], marketDays: number, res: any) {
    if (res) {
      RentalEndDate: this.datePipe.transform(new Date(rentalDates[rentalDates.length - 1].startDate), 'MMM d, y'),
        this.selectedMonthlyBooths[recordExist].RentalEndDate = this.datePipe.transform(new Date(rentalDates[rentalDates.length - 1].startDate), 'MMM d, y');
      this.selectedMonthlyBooths[recordExist].MktDays = marketDays;
      this.selectedMonthlyBooths[recordExist].Rent = this.customCurrency.transform(res.Rent);
      this.selectedMonthlyBooths[recordExist].SalesTax = this.customCurrency.transform(res.SalesTax);
      this.selectedMonthlyBooths[recordExist].CityTax = this.customCurrency.transform(res.CityTax);
      this.selectedMonthlyBooths[recordExist].January = this.customCurrency.transform(res.JanRent);
      this.selectedMonthlyBooths[recordExist].February = this.customCurrency.transform(res.FebRent);
      this.selectedMonthlyBooths[recordExist].March = this.customCurrency.transform(res.MarRent);
      this.selectedMonthlyBooths[recordExist].April = this.customCurrency.transform(res.AprRent);
      this.selectedMonthlyBooths[recordExist].May = this.customCurrency.transform(res.MayRent);
      this.selectedMonthlyBooths[recordExist].June = this.customCurrency.transform(res.JunRent);
      this.selectedMonthlyBooths[recordExist].July = this.customCurrency.transform(res.JulRent);
      this.selectedMonthlyBooths[recordExist].August = this.customCurrency.transform(res.AugRent);
      this.selectedMonthlyBooths[recordExist].September = this.customCurrency.transform(res.SepRent);
      this.selectedMonthlyBooths[recordExist].October = this.customCurrency.transform(res.OctRent);
      this.selectedMonthlyBooths[recordExist].November = this.customCurrency.transform(res.NovRent);
      this.selectedMonthlyBooths[recordExist].December = this.customCurrency.transform(res.DecRent);
      this.selectedMonthlyBooths[recordExist].JanuaryMonthPresent = res.JanuaryMonthPresent;
      this.selectedMonthlyBooths[recordExist].FebruaryMonthPresent = res.FebruaryMonthPresent;
      this.selectedMonthlyBooths[recordExist].MarchMonthPresent = res.MarchMonthPresent;
      this.selectedMonthlyBooths[recordExist].AprilMonthPresent = res.AprilMonthPresent;
      this.selectedMonthlyBooths[recordExist].MayMonthPresent = res.MayMonthPresent;
      this.selectedMonthlyBooths[recordExist].JuneMonthPresent = res.JuneMonthPresent;
      this.selectedMonthlyBooths[recordExist].JulyMonthPresent = res.JulyMonthPresent;
      this.selectedMonthlyBooths[recordExist].AugustMonthPresent = res.AugustMonthPresent;
      this.selectedMonthlyBooths[recordExist].SeptemberMonthPresent = res.SeptemberMonthPresent;
      this.selectedMonthlyBooths[recordExist].OctoberMonthPresent = res.OctoberMonthPresent;
      this.selectedMonthlyBooths[recordExist].NovemberMonthPresent = res.NovemberMonthPresent;
      this.selectedMonthlyBooths[recordExist].DecemberMonthPresent = res.DecemberMonthPresent;
      this.selectedMonthlyBooths[recordExist].DisableJanMonth = res.JanRent || res.JanRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableFebMonth = res.FebRent || res.FebRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableMarMonth = res.MarRent || res.MarRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableAprMonth = res.AprRent || res.AprRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableMayMonth = res.MayRent || res.MayRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableJunMonth = res.JunRent || res.JunRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableJulMonth = res.JulRent || res.JulRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableAugMonth = res.AugRent || res.AugRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableSepMonth = res.SepRent || res.SepRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableOctMonth = res.OctRent || res.OctRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableNovMonth = res.NovRent || res.NovRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableDecMonth = res.DecRent || res.DecRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].ExtendRental = true;
      this.selectedMonthlyBooths[recordExist].AllRentalDates =  rentalDates.map(el => new Date(el.startDate));
      this.updateTotalCharges(res.Rent, res.SalesTax, res.CityTax);
    }
  }

  private updateTotalCharges(Rent, SalesTax, CityTax) {
    this.totalRentalCharge += Rent;
    this.totalSalesTax += SalesTax;
    this.totalSecondLeveltax += CityTax;
    this.updateCharges();
  }

  getMonthlyOtherRentals() {
    this.loaderIcon = Promise.resolve(true);
    this.selectedOtherItems = [];
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;
    const currentYearMonth = `${currentYear}${currentMonth < 10 ? '0' : ''}${currentMonth}`;
    const pastMonthFormattedDate = this.datePipe.transform(new Date(currentYear, currentMonth - 2, 1), 'MMMM yyyy');

    const sub = this.rentalService.getMonthlyOtherRentals(this.marketId, this.vendorId).subscribe(async (res: any[]) => {
      if (res) {
        this.allrentedOtherItems = res;

        // Keep only the record with the highest YearMonth per unique key (OtherItemId + Reference + BoothNumber)
        const isValidYearMonth = (ym: string) => typeof ym === 'string' && /^\d{6}$/.test(ym);
        const allRecordsMap = new Map<string, any>();
        for (const el of res) {
          if (!isValidYearMonth(el.YearMonth)) continue;
          const key = `${el.OtherItemId}_${el.Reference}_${el.BoothNumber ?? 'none'}`;
          const existing = allRecordsMap.get(key);
          if (!existing || el.YearMonth > existing.YearMonth) {
            allRecordsMap.set(key, el);
          }
        }
        const filteredRes = Array.from(allRecordsMap.values());

        for (const el of filteredRes) {
          const boothNo = el.BoothNumber ? el.BoothNumber : "none";

          if (el.YearMonth >= currentYearMonth) {
            console.log('selectedOtherItems', this.selectedOtherItems);
            const formattedDate = this.datePipe.transform(
              new Date(parseInt(el.YearMonth.substring(0, 4)), parseInt(el.YearMonth.substring(4, 6)) - 1, 1),
              'MMMM yyyy'
            );
            const rentEndPeriodIndex = this.monthlyMarketDays.findIndex(e => e.RentalMonths == formattedDate);
            const nextIndex = rentEndPeriodIndex + 1;
            const renewalStartMonth = (rentEndPeriodIndex >= 0 && nextIndex < this.monthlyMarketDays.length)
              ? this.monthlyMarketDays[nextIndex].RentalMonths : "";

            const index = this.selectedOtherItems.findIndex(item =>
              item.Id === el.OtherItemId &&
              item.RentalMonth == formattedDate &&
              item.Reference == el.Reference &&
              item.BoothNo == boothNo &&
              item.Recurring == el.Recurring
            );
            if (index !== -1) {
              this.selectedOtherItems[index].Quantity += el.Quantity;
              this.selectedOtherItems[index].MonthlyRentalIds += ',' + el.OtherRentalId;
              this.selectedOtherItems[index].OtherItemtotal = this.customCurrency.transform((el.OtherCharge * this.selectedOtherItems[index].Quantity).toString());
            } else {
              const recordExist = this.selectedOtherItems.findIndex(e =>
                e.RentalMonth == formattedDate &&
                e.Id == el.OtherItemId &&
                e.Reference == el.Reference &&
                e.BoothNo == boothNo
              );
              const newItem = {
                Id: el.OtherItemId,
                MonthOtherRentalId: el.OtherRentalId,
                OtherItem: el.OtherItemName,
                OtherItemCharge: this.customCurrency.transform("0"),
                Quantity: el.Quantity,
                OtherItemtotal: this.customCurrency.transform("0"),
                RentalMonth: formattedDate,
                SalesTax: this.customCurrency.transform('0'),
                CityTax: this.customCurrency.transform('0'),
                CurrentRentalMonth: formattedDate,
                CurrentOtherItemtotal: this.customCurrency.transform(el.OtherCharge.toString()),
                CurrentSalesTax: this.customCurrency.transform(el.SalesTax.toString()),
                CurrentSecLevelTax: this.customCurrency.transform(el.SecLevelTax.toString()),
                BoothNo: boothNo,
                Recurring: el.Recurring,
                Reference: el.Reference,
                NewItem: false,
                MonthlyRentalIds: el.OtherRentalId.toString(),
                RenewalStartMonth: renewalStartMonth,
                MonthlyRenewalMonth: renewalStartMonth,
                BookingCanExtend: true,
                RentEndPeriodIndex: rentEndPeriodIndex
              };
              if (recordExist == -1) {
                this.selectedOtherItems.push(newItem);
              } else {
                const existingRenewalMonth = this.selectedOtherItems[recordExist].RenewalStartMonth;
                const incomingYearMonth = renewalStartMonth ? new Date(renewalStartMonth).getTime() : 0;
                const existingYearMonth = existingRenewalMonth ? new Date(existingRenewalMonth).getTime() : 0;
                if (incomingYearMonth > existingYearMonth) {
                  this.selectedOtherItems[recordExist] = newItem;
                }
              }
            }
          } else {
            console.log('monthlyMarketDays', this.monthlyMarketDays);
            const res = await this.rentalService.getOtherItemsRentalCharges({
              MarketId: this.marketId,
              OtherItemId: el.OtherItemId,
              VendorId: this.vendorId,
              Quantity: el.Quantity,
              OtherItemCharge: el.OtherCharge
            }).toPromise();
            if (res) {
              const recordExist = this.selectedOtherItems.findIndex(e =>
                e.RentalMonth == pastMonthFormattedDate &&
                e.Id == el.OtherItemId &&
                e.Reference == el.Reference &&
                e.BoothNo == boothNo
              );
              if (recordExist == -1) {
                this.selectedOtherItems.push({
                  Id: el.OtherItemId,
                  MonthOtherRentalId: el.OtherRentalId,
                  OtherItem: el.OtherItemName,
                  OtherItemCharge: this.customCurrency.transform(el.OtherCharge),
                  Quantity: el.Quantity,
                  OtherItemtotal: this.customCurrency.transform((el.OtherCharge * el.Quantity).toString()),
                  RentalMonth: pastMonthFormattedDate,
                  SalesTax: this.customCurrency.transform(res.SalesTax.toString()),
                  CityTax: this.customCurrency.transform(res.CityTax.toString()),
                  CurrentRentalMonth: pastMonthFormattedDate,
                  CurrentOtherItemtotal: this.customCurrency.transform(el.OtherCharge.toString()),
                  CurrentSalesTax: this.customCurrency.transform(el.SalesTax.toString()),
                  CurrentSecLevelTax: this.customCurrency.transform(el.SecLevelTax.toString()),
                  BoothNo: boothNo,
                  Recurring: el.Recurring,
                  Reference: el.Reference,
                  NewItem: false,
                  MonthlyRentalIds: '',
                  Status: "R",
                  RentEndPeriodIndex: 0,
                  BookingCanExtend: true,
                  RenewalStartMonth: this.monthlyMarketDays[0].RentalMonths,
                  MonthlyRenewalMonth: this.monthlyMarketDays[0].RentalMonths,
                });
                if (this.allowOtherItemRenewal) {
                  this.totalOtherRentalCharge += el.OtherCharge * el.Quantity;
                  this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
                  this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
                  this.updateCharges();
                }
              }
            }
          }
        }

        this.renewMonthlyOtherCharges();
        this.loaderIcon = Promise.resolve(false);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  saveRentalWithPayment() {
    this.savePayment = false;
    var creditCardAmount = this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentAmount').value);
    var convenienceFee = this.getActualAmountFromInp(this.bookingDetailsForm.get('convenienceFee').value);
    const totalAmountPaid = creditCardAmount  + convenienceFee;
    if (totalAmountPaid != 0 || (totalAmountPaid == 0 && this.paymentAdjustedWithPriorBal)) {
      Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Are you sure you want to proceed with the payment?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,
      }).then((result) => {
        if (result.value) {
          if (this.paymentAdjustedWithPriorBal) {
            var obj = {
              PaymentSuccess: true,
              OrderId: "",
              VerifoneId: 0
            }
            this.savePayment = true;
            this.PaymentResponse(obj)
          } else {
            if (this.paymentGatewayCredentials && this.processCreditCardOnline) {
              this.processPayment = true;
              this.hideTopHeaders.emit(true);
            }
            else {
              Swal.fire({
                title: $localize`Warning`,
                text: $localize`Credit card cannot be processed.`,
                icon: "warning",
                confirmButtonText: $localize`Ok`,
              });
            }
          }
        }
      });
    }
    else {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Please enter the payment amount!`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
    }
  }

  PaymentResponse(response) {
    this.loaderIcon = Promise.resolve(true);
    if (response.PaymentSuccess) {
      this.verifoneId = response.VerifoneId;
      switch (this.rentalType) {
        case 2:
          var convenienceFee = this.getActualAmountFromInp(this.bookingDetailsForm.get('convenienceFee').value);
          if (convenienceFee > 0 && this.paymentOnly) {
            this.paymentOnly = false;
          }
          var objM = {
            VendorId: this.vendorId,
            PaymentOrderId: response.OrderId,
            RentalCharge: this.getActualAmountFromInp(this.bookingDetailsForm.get('rentalCharge').value),
            SalesTax: 0,
            SecLevelTax: 0,
            OtherCharge: this.getActualAmountFromInp(this.bookingDetailsForm.get('otherCharge').value),
            PriorBalance: this.getActualAmountFromInp(this.bookingDetailsForm.get('priorBalance').value),
            TotalBalanceDue: this.getActualAmountFromInp(this.bookingDetailsForm.get('balanceDue').value),
            RentalNotes: "",
            CashAmount: 0,
            CheckAmount: 0,
            CheckNo: "",
            ChangeAmount: 0,
            CardAmount: this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentAmount').value),
            DirectDebitAmount: 0,
            CardType: "",
            PaymentDone: true,
            WebRentalRequest: true,
            PaymentDueDate: null,
            VerifoneId: response.VerifoneId,
            DiscountAmount: this.getActualAmountFromInp(this.bookingDetailsForm.get('discount').value),
            ConvenienceFee: this.getActualAmountFromInp(this.bookingDetailsForm.get('convenienceFee').value),
            BookingFee: this.getActualAmountFromInp(this.bookingDetailsForm.get('additionalCharge').value),
            MonthlyRentalBooth: [],
            MonthlyOtherRentalCharges: [],
            AppliedDiscountModel: [],
            LateFeeAmount : this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentLateFee').value ?? 0)
          }

          var objSelectedBooth = [];
          if (this.selectedMonthlyBooths.length > 0) {
            this.selectedMonthlyBooths.forEach((item, i) => {
              const rentalStartDateYear = new Date(item.RentalEndDate).getFullYear();
              const rentalStartDateMonth = new Date(item.RentalEndDate).getMonth() + 1;
              const rentalStartDateYearMonth = `${rentalStartDateYear}${rentalStartDateMonth < 10 ? '0' : ''}${rentalStartDateMonth}`;
              if (item.Reservation) {
                objSelectedBooth.push({
                  MonthlyRentalId: item.MonthlyRentalId,
                  BoothNumber: item.BoothNumber,
                  BoothTypeId: item.BoothTypeId,
                  ProductId: item.Product,
                  BoothType: item.BoothType,
                  RentalStartDate: new Date(item.RentalStartDate),
                  RentalEndDate: new Date(item.RentalEndDate),
                  RentalYearMonth: rentalStartDateYearMonth,
                  BoothReserved: item.Reservation,
                  DoNotRenew: item.Drop,
                  PerDiem: item.PerDiem,
                  PerdiemRent: this.getActualAmountFromInp(item.PerDiemRent),
                  Monday: item.Monday,
                  Tuesday: item.Tuesday,
                  Wednesday: item.Wednesday,
                  Thursday: item.Thursday,
                  Friday: item.Friday,
                  Saturday: item.Saturday,
                  Sunday: item.Sunday,
                  RentalCharge: this.getActualAmountFromInp(item.Rent),
                  SalesTax: this.getActualAmountFromInp(item.SalesTax),
                  SecLevelTax: this.getActualAmountFromInp(item.CityTax),
                  JanRent: item.January ? this.getActualAmountFromInp(item.January) : 0,
                  FebRent: item.February ? this.getActualAmountFromInp(item.February) : 0,
                  MarRent: item.March ? this.getActualAmountFromInp(item.March) : 0,
                  AprRent: item.April ? this.getActualAmountFromInp(item.April) : 0,
                  MayRent: item.May ? this.getActualAmountFromInp(item.May) : 0,
                  JunRent: item.June ? this.getActualAmountFromInp(item.June) : 0,
                  JulRent: item.July ? this.getActualAmountFromInp(item.July) : 0,
                  AugRent: item.August ? this.getActualAmountFromInp(item.August) : 0,
                  SepRent: item.September ? this.getActualAmountFromInp(item.September) : 0,
                  OctRent: item.October ? this.getActualAmountFromInp(item.October) : 0,
                  NovRent: item.November ? this.getActualAmountFromInp(item.November) : 0,
                  DecRent: item.December ? this.getActualAmountFromInp(item.December) : 0,
                  BookingLog: i + 1,
                  AllRentalDates: item.AllRentalDates
                });
              }
            });
          }

          if (objSelectedBooth.length > 0)
            objM.MonthlyRentalBooth = objSelectedBooth;

          var objSelectedOtherCharge = [];
          if (this.selectedOtherItems.length > 0) {
            this.selectedOtherItems.forEach((item) => {
              const otherRentalYear = new Date(item.MonthlyRenewalMonth.split('-')[0]).getFullYear();
              const otherRentalMonth = new Date(item.MonthlyRenewalMonth.split('-')[0]).getMonth() + 1;
              const otherRentalYearMonth = `${otherRentalYear}${otherRentalMonth <
                10 ? '0' : ''}${otherRentalMonth}`;

              if (item.Recurring && this.allowOtherItemRenewal) {
                objSelectedOtherCharge.push({
                  OtherItemId: item.Id,
                  MonthOtherRentalId: item.MonthOtherRentalId,
                  OtherItemName: item.OtherItem,
                  OtherItemCharge: this.getActualAmountFromInp(item.OtherItemtotal),
                  Quantity: item.Quantity,
                  YearMonth: otherRentalYearMonth,
                  BoothNumber: item.BoothNo,
                  Recurring: item.Recurring,
                  OtherCharge: this.getActualAmountFromInp(item.OtherItemCharge),
                  SalesTax: this.getActualAmountFromInp(item.SalesTax),
                  SecLevelTax: this.getActualAmountFromInp(item.CityTax),
                  Reference: item.Reference
                })
              }
            });
          }
          if (this.allowRenewalsFee && this.allowRenewalsFeeId && this.onlineBookingFeeApplied) {
            const now = new Date();
            const nowYearMonth = `${now.getFullYear()}${(now.getMonth() + 1) < 10 ? '0' : ''}${now.getMonth() + 1}`;
            objSelectedOtherCharge.push({
              OtherItemId: this.allowRenewalsFeeId,
              MonthOtherRentalId: 0,
              OtherItemName: "Online Booking Fee",
              OtherItemCharge: this.getActualAmountFromInp(this.onlineBookingFeeAmount),
              Quantity: 1,
              YearMonth: nowYearMonth,
              BoothNumber: "none",
              Recurring: false,
              OtherCharge: this.getActualAmountFromInp(this.onlineBookingFeeAmount),
              SalesTax: 0,
              SecLevelTax: 0,
              Reference: null
            });
          }
          if (objSelectedOtherCharge.length > 0)
            objM.MonthlyOtherRentalCharges = objSelectedOtherCharge;

          var objDiscountData = [];
          if (this.vendorDiscountPlans.length > 0 && this.totalDiscountCharge > 0) {
            this.vendorDiscountPlans.forEach((item) => {
              if (item.CheckAll) {
                objDiscountData.push({
                  PlanId: item.PlanSeqId,
                  DiscountAmount:  this.getActualAmountFromInp(item.AppliedDiscount),
                  OtherCharges: item.OtherItems,
                  SalesTax: this.getActualAmountFromInp(item.SalesTaxApplied),
                  SecondLevelTax: this.getActualAmountFromInp(item.SecondLevelTaxApplied),
                  DiscountType: item.DiscountType == DiscountType.Percentage ? "0" : "1",
                  DiscountValue: item.DiscountValue,
                  SalesTaxAmount: this.getActualAmountFromInp(item.SalesTaxAmount),
                  SecondLevelTaxAmount: this.getActualAmountFromInp(item.SecondLevelTaxAmount)
                })
              }
            });
          }
          if (objDiscountData.length > 0)
            objM.AppliedDiscountModel = objDiscountData;

          const subCM = this.rentalService.saveMonthlyRental(this.marketId,objM).subscribe(async (res: any) => {
            if (res.Success) {
              this.accountReceipId = res.Id;
              this.toastr.success($localize`Transaction saved successfully`, $localize`Success`, this.toasterConfig);
              this.processPayment = false;
              this.openConfirmationPage = true;
            } else {
              this.toastr.error($localize`Error occurred while saving the rental transaction`, $localize`Error`, this.toasterConfig);
              if (this.verifoneId) {
                this.voidPayment = true;
              }
            }
            this.loaderIcon = Promise.resolve(false);
          }, (err) => {
            this.toastr.error($localize`Error occurred while saving the rental transaction`, $localize`Error`, this.toasterConfig);
            // const url = 'ops/vendors/details/' + this.vendorId + '/3';
            // this.router.navigate([url]);

            this.loaderIcon = Promise.resolve(false);
          });

          this.subscriptions.push(subCM);
          break;

        case 3: {
          const amt = (val: any) => this.getActualAmountFromInp(val);

          const objWeekly: any = {
            VendorId: this.vendorId,
            PaymentOrderId: response.OrderId,
            RentalCharge: amt(this.bookingDetailsForm.get('rentalCharge').value),
            SalesTax: amt(this.bookingDetailsForm.get('totalSalesTax').value),
            SecLevelTax: amt(this.bookingDetailsForm.get('totalSecondLeveltax').value),
            OtherCharge: amt(this.bookingDetailsForm.get('otherCharge').value),
            PriorBalance: amt(this.bookingDetailsForm.get('priorBalance').value),
            TotalBalanceDue: amt(this.bookingDetailsForm.get('balanceDue').value),
            RentalNotes: "",
            CashAmount: 0,
            CheckAmount: 0,
            CheckNo: "",
            ChangeAmount: 0,
            CardAmount: amt(this.bookingDetailsForm.get('paymentAmount').value),
            DirectDebitAmount: 0,
            CardType: "",
            PaymentDone: true,
            WebRentalRequest: true,
            PaymentDueDate: null,
            VerifoneId: response.VerifoneId,
            DiscountAmount: amt(this.bookingDetailsForm.get('discount').value),
            ConvenienceFee: amt(this.bookingDetailsForm.get('convenienceFee').value),
            BookingFee: amt(this.bookingDetailsForm.get('additionalCharge').value),
            WeeklyRentalBooth: [],
            WeeklyRentalOtherCharges: [],
            AppliedDiscountModel: [],
            LateFeeAmount: amt(this.bookingDetailsForm.get('paymentLateFee').value ?? 0)
          };

          objWeekly.WeeklyRentalBooth = this.selectedWeeklyBooths
            .filter(item => item.Reservation && !item.BlockRenewal)
            .map((item, i) => {
              const start = item.RentStartPeriod?.split('-')?.[0];
              const end = item.CWRenewalWeek?.split('-')?.[1];

              return {
                WeeklyRentalId: item.WeeklyRentalId,
                BoothNumber: item.BoothNumber,
                BoothTypeId: item.BoothTypeId,
                ProductId: item.Product,
                BoothType: item.BoothType,
                RentalWeeekStartDate: start ? new Date(start) : null,
                RentalWeeekEndDate: end ? new Date(end) : null,
                RentalStartDate: item.RentalStartDate ? new Date(item.RentalStartDate) : null,
                RentalEndDate: item.RentalEndDate ? new Date(item.RentalEndDate) : null,
                SelectedRentalDates: "",
                BoothReserved: item.Reservation,
                DoNotRenew: item.Drop,
                PerDiem: item.PerDiem,
                PerdiemRent: amt(item.PerDiemRent),
                Monday: item.Monday,
                Tuesday: item.Tuesday,
                Wednesday: item.Wednesday,
                Thursday: item.Thursday,
                Friday: item.Friday,
                Saturday: item.Saturday,
                Sunday: item.Sunday,
                RentalCharge: amt(item.Rent),
                SalesTax: amt(item.SalesTax),
                SecLevelTax: amt(item.CityTax),
                JanRent: item.January ? amt(item.January) : 0,
                FebRent: item.February ? amt(item.February) : 0,
                MarRent: item.March ? amt(item.March) : 0,
                AprRent: item.April ? amt(item.April) : 0,
                MayRent: item.May ? amt(item.May) : 0,
                JunRent: item.June ? amt(item.June) : 0,
                JulRent: item.July ? amt(item.July) : 0,
                AugRent: item.August ? amt(item.August) : 0,
                SepRent: item.September ? amt(item.September) : 0,
                OctRent: item.October ? amt(item.October) : 0,
                NovRent: item.November ? amt(item.November) : 0,
                DecRent: item.December ? amt(item.December) : 0,
                BookingLog: i + 1
              };
            });

          objWeekly.WeeklyRentalOtherCharges = this.selectedOtherItems
            .filter(item => item.Recurring && this.allowOtherItemRenewal)
            .map(item => ({
              OtherItemId: item.Id,
              WeekOtherRentalId: item.WeekOtherRentalId,
              Quantity: item.Quantity,
              OtherItemName: item.OtherItem,
              OtherItemCharge: amt(item.OtherItemtotal),
              RentalWeek: item.RentalWeek?.split('-')?.[0],
              BoothNumber: item.BoothNo,
              Recurring: item.Recurring,
              OtherCharge: amt(item.OtherItemCharge),
              SalesTax: amt(item.SalesTax),
              SecLevelTax: amt(item.CityTax),
              Reference: item.Reference,
              WeeklyOtherRentalIds: item.WeeklyOtherRentalIds
            }));

          if (this.allowRenewalsFee && this.allowRenewalsFeeId && this.onlineBookingFeeApplied) {
            objWeekly.WeeklyRentalOtherCharges.push({
              OtherItemId: this.allowRenewalsFeeId,
              WeekOtherRentalId: 0,
              Quantity: 1,
              OtherItemName: "Online Booking Fee",
              OtherItemCharge: amt(this.onlineBookingFeeAmount),
              RentalWeek: this.weeklyMarketDays?.[0]?.RentalStartDays?.split('-')?.[0],
              BoothNumber: "none",
              Recurring: false,
              OtherCharge: amt(this.onlineBookingFeeAmount),
              SalesTax: 0,
              SecLevelTax: 0,
              Reference: null,
              WeeklyOtherRentalIds: ''
            });
          }

          objWeekly.AppliedDiscountModel = this.vendorDiscountPlans
            .filter(item => item.CheckAll && this.totalDiscountCharge > 0)
            .map(item => ({
              PlanId: item.PlanSeqId,
              DiscountAmount: amt(item.AppliedDiscount),
              OtherCharges: item.OtherItems,
              SalesTax: item.SalesTaxApplied,
              SecondLevelTax: item.SecondLevelTaxApplied,
              DiscountType: item.DiscountType == DiscountType.Percentage ? "0" : "1",
              DiscountValue: item.DiscountValue,
              SalesTaxAmount: amt(item.SalesTaxAmount),
              SecondLevelTaxAmount: amt(item.SecondLevelTaxAmount)
            }));

          const subW = this.rentalService.SaveWeeklyRentalTransactions(objWeekly)
            .pipe(
              finalize(() => {
                this.loaderIcon = Promise.resolve(false);
              })
            )
            .subscribe({
              next: (res: any) => {
                if (res.Success) {
                  this.accountReceipId = res.Id;
                  this.toastr.success(
                    $localize`Transaction saved successfully`,
                    $localize`Success`,
                    this.toasterConfig
                  );
                  this.processPayment = false;
                  this.openConfirmationPage = true;
                } else {
                  this.toastr.error(
                    $localize`Error occurred while saving the rental transaction`,
                    $localize`Error`,
                    this.toasterConfig
                  );
                  if (this.verifoneId) this.voidPayment = true;
                }
              },
              error: () => {
                this.toastr.error(
                  $localize`Error occurred while saving the rental transaction`,
                  $localize`Error`,
                  this.toasterConfig
                );
                if (this.verifoneId) this.voidPayment = true;
              }
            });

          this.subscriptions.push(subW);
          break;
        }
      }
    }
    else {
      this.processPayment = false;
      this.hideTopHeaders.emit(false);
      this.voidPayment = false;
      this.loaderIcon = Promise.resolve(false);
    }
  }

  getTotalCharge() {
    var totalrentalCharge = this.getActualAmountFromInp(this.bookingDetailsForm.get('rentalCharge')?.value ?? 0);
    var otherRentalCharge = this.getActualAmountFromInp(this.bookingDetailsForm.get('otherCharge')?.value ?? 0);
    var totalSalesTax = this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSalesTax')?.value ?? 0);
    var totalSecondLeveltax = this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSecondLeveltax')?.value ?? 0);
    var vendorLateFee = this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentLateFee')?.value ?? 0);
    var totalCharge = (this.actualTotalDue ?? 0) + totalrentalCharge + otherRentalCharge + (this.renewalFeeAmount ?? 0) + totalSalesTax + totalSecondLeveltax + vendorLateFee;
    return totalCharge;
  }

  setMinimum(controls) {
    const value = controls.value;
    var enteredAmount = this.getActualAmountFromInp(value.toString());
    if (!enteredAmount) {
      controls.setValue(this.customCurrency.transform("0.00"));
    }

    var totalDue = this.getTotalCharge();
    if (enteredAmount > totalDue) {
      this.bookingDetailsForm.get("paymentAmount").setValue(this.customCurrency.transform(totalDue.toString()));
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Payment amount cannot be greater than total due.`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
    }
    this.calculateBalance();
  }

  calculateBalance() {
    var creditCardAmount = this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentAmount')?.value ?? 0);
    var totalrentalCharge = this.getActualAmountFromInp(this.bookingDetailsForm.get('rentalCharge')?.value ?? 0);
    var otherRentalCharge = this.getActualAmountFromInp(this.bookingDetailsForm.get('otherCharge')?.value ?? 0);
    var totalSalesTax = this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSalesTax')?.value ?? 0);
    var totalSecondLeveltax = this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSecondLeveltax')?.value ?? 0);
    var vendorLateFee = this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentLateFee')?.value ?? 0);
    var renewalFee = this.getActualAmountFromInp(this.renewalFeeAmount);
    if (this.onlineBookingFeeApplied) {
      renewalFee += this.getActualAmountFromInp(this.onlineBookingFeeAmount);
    }

    var currentRentalCharge = totalrentalCharge + otherRentalCharge + totalSalesTax + totalSecondLeveltax + renewalFee + vendorLateFee;
    var totalDue = this.actualTotalDue + totalrentalCharge + otherRentalCharge + totalSalesTax + totalSecondLeveltax + vendorLateFee;
    totalDue = parseFloat(totalDue.toFixed(2))
    if (totalDue > 0) {
      totalDue = totalDue + renewalFee;
    }
    else{
      renewalFee = 0;
      currentRentalCharge -= this.getActualAmountFromInp(this.renewalFeeAmount);
      if (this.onlineBookingFeeApplied) {
        currentRentalCharge -= this.getActualAmountFromInp(this.onlineBookingFeeAmount);
      }
    }

    if (this.actualTotalDue < 0 && (totalDue <= 0)) {
      totalDue = 0;
      creditCardAmount = 0;
    }
    if (!this.AllowPartialPay) {
      creditCardAmount = totalDue > 0 ? totalDue : 0;
    }
    this.creditCardAmount = creditCardAmount;
    const convenienceFee = 0;

    var totalAmount;
    totalAmount = creditCardAmount + convenienceFee;
    var balanceAmount = totalDue != 0 ? totalDue - totalAmount : 0;

    if(this.actualTotalDue < 0 && currentRentalCharge == 0){
      balanceAmount = this.actualTotalDue;
      totalAmount = 0;
    }
    else if (this.actualTotalDue < 0 && (totalDue <= 0)) {
      balanceAmount = this.actualTotalDue + currentRentalCharge;
      totalDue = currentRentalCharge;
    }
    this.bookingDetailsForm.patchValue({
      totalCharge: this.customCurrency.transform(totalDue.toString()),
      balanceDue: this.customCurrency.transform(balanceAmount.toString()),
      convenienceFee: this.customCurrency.transform(convenienceFee.toString()),
      additionalCharge: this.customCurrency.transform(renewalFee.toString()),
      totalPayment: this.customCurrency.transform(totalAmount.toString()),
      paymentAmount: this.customCurrency.transform(creditCardAmount.toString()),
    }, { emitEvent: false })

    this.paymentAmount = this.getActualAmountFromInp(this.bookingDetailsForm.get('totalPayment').value);

    if (this.applyCCCharge && creditCardAmount > 0) {
      this.calculateConvenienceFee();
    }
  }

  handledblClick(event: any) {
    clearTimeout(this.clickTimeout);

    const inputElement = event.target as HTMLInputElement;
    inputElement.select(); // Select the entire text on double-click
  }

  handleClick(event: any) {
    // Get the current value of the input field
    let currentValue: string = event.target.value;
    const currentCursorPosition = event.target.selectionStart;
    const currentSelectionLength = event.target.selectionEnd - event.target.selectionStart;
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value;
    clearTimeout(this.clickTimeout);

    this.clickTimeout = setTimeout(() => {
      if (inputValue === '$0.00') {
        const selectionLength = inputElement.selectionEnd - inputElement.selectionStart;

        // If the entire text is not selected, set the cursor position after the "$" sign
        if (selectionLength !== inputValue.length) {
          inputElement.setSelectionRange(1, 1);
        }
      }
    }, 200); // Delay to check for double click

    if (currentSelectionLength === currentValue.length) {
      return true;
    }
    // Check if the input value is "$0.00"
    if (currentValue === '$0.00') {
      // Set the cursor position after the "$" sign
      event.target.setSelectionRange(1, 1);
      return;
    }

    // Check if the "$" sign is present in the current value
    const hasDollarSign = currentValue.includes('$');
    // Get the cursor position
    const caretPosition = event.target.selectionStart;
    // Check if the cursor position is after the "$" sign
    const hasDollarSignBeforeCaret = currentValue.slice(0, caretPosition).includes('$');
    // If the cursor is not after the "$" sign, adjust the cursor position
    if (!hasDollarSignBeforeCaret && hasDollarSign) {
      // Find the index of "$" sign
      const dollarSignIndex = currentValue.indexOf('$');
      // Set the cursor position after the "$" sign
      event.target.setSelectionRange(dollarSignIndex + 1, dollarSignIndex + 1);
    }
  }

  setCurrencyFormat(controls) {
    const value = controls.value;
    let inputValue = value;
    if(inputValue.toString().substring(1,2) == "$")
      inputValue = `${inputValue.slice(1)}`;
    controls.setValue(inputValue);
  }


  numberOnly(event): boolean {
    const inputValue = event.target.value;
    const charCode = (event.which) ? event.which : event.keyCode;
    const currentCursorPosition = event.target.selectionStart;
    const currentSelectionLength = event.target.selectionEnd - event.target.selectionStart;
    // Check if the input value is "$0.00"
    if (charCode == 45) {
      return false;
    }
    if (currentSelectionLength === inputValue.length) {
      return true;
    }
    if (inputValue === '$0.00') {
      // Set the cursor position after the "$" sign
      event.target.setSelectionRange(1, 1);
      return true; // Allow further input
    }
    // Check if the "$" sign is present in the current value
    const hasDollarSign = inputValue.includes('$');
    // Check if the cursor position is after the "$" sign
    const hasDollarSignBeforeCaret = inputValue.slice(0, currentCursorPosition).includes('$');
    // If the cursor is not after the "$" sign and "$" sign is present, prevent input
    if (!hasDollarSignBeforeCaret && hasDollarSign && charCode !== 46 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    // If the entered character is a dot and there's already a dot in the input, prevent input
    if (charCode == 46 && inputValue.includes('.') && inputValue.indexOf('.') !== currentCursorPosition) {
      return false;
    }
    if (charCode > 31 && (charCode < 46 || charCode > 57 || charCode === 47)) {
      return false;
    }
    return true; // Allow input
  }

  getCCCredentials() {
    this.paymentService.getCCCredentials(this.marketId).subscribe((res) => {
      if (res !== null) {
        this.paymentGatewayCredentials = res.GatewayDetails ? JSON.parse(res.GatewayDetails) : null;
        this.processCreditCardOnline = res.ProcessCreditCardOnline;
        const gatewayId = Number(res.PaymentGateWay);
        this.isStripeEnabled = gatewayId == EPaymentGateway.Stripe;
        this.isOpenEdgenEnabled = gatewayId == EPaymentGateway.OpenEdgeExpress;
      }
    })
  }

  getWebRentalSetting() {
    const sub = this.marketInfoService.getWebRentalSetting(this.marketId).subscribe((res: any) => {
      if (res) {
        this.applyCCCharge = res.ApplyCcporcessingFeePercentage;
        this.CCFeeType = res.CCFeeType;
        this.CcfeeinPercentage = res.CcfeeinPercentage;
        this.AllowPartialPay = res.AllowPartialPay;
        this.allowWeeklyRentalRenewal = res.AllowRenewalsMonthly;
        this.allowMonthlyRentalRenewal = res.AllowRenewalsMonthly;
        this.applyRentalRenewalAvailability();
        this.allowOtherItemRenewal = res.AllowRenewingOtherItems;
        this.preventVendorUncheckOtherItemRenewal = res.PreventVendorUncheckOtherItemRenewal ?? false;
        //this.applyRenewalFee = res.ApplyBookingFee;
        this.UnchkBoothOnOthChgRemoval = res.UnchkBoothOnOthChgRemoval ?? false;
        //this.bookingRenewalFeeId = res.ApplyBookingFeeId;
        if (this.bookingRenewalFeeId) {
          this.subscriptions.push(this.rentalService.getBookingRenewalFeeById(this.marketId, this.bookingRenewalFeeId).subscribe((resFee: any) => {
            if (resFee) {
              this.renewalFeeAmount = (this.rentalType == 2 ? resFee.OtherItemMonthlyCharge :
                this.rentalType == 3 ? resFee.OtherItemWeeklyCharge : 0) ?? 0;
            }
          }));
        }

        this.allowRenewalsFee = res.AllowRenewalsFee ?? false;
        this.allowRenewalsFeeId = res.AllowRenewalsFeeId;
        if (this.allowRenewalsFee && this.allowRenewalsFeeId) {
          this.subscriptions.push(this.rentalService.getBookingRenewalFeeById(this.marketId, this.allowRenewalsFeeId).subscribe((resFee: any) => {
            if (resFee) {
              this.onlineBookingFeeAmount = (this.rentalType == 2 ? resFee.OtherItemMonthlyCharge :
                this.rentalType == 3 ? resFee.OtherItemWeeklyCharge : 0) ?? 0;
              this.applyOnlineBookingFeeIfNeeded();
            }
          }));
        }
        this.bookingDetailsForm.get('paymentAmount').enable();
        if (!this.AllowPartialPay) {
          this.bookingDetailsForm.get('paymentAmount').disable();
          this.bookingDetailsForm.patchValue({
            paymentAmount: this.customCurrency.transform(this.actualTotalDue.toString()),
            totalPayment: this.customCurrency.transform(this.actualTotalDue.toString()),
          })
        }
        this.paymentAmount = this.getActualAmountFromInp(this.bookingDetailsForm.get('totalPayment').value);
        const creditCardAmount = this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentAmount').value);
        if (this.applyCCCharge && creditCardAmount > 0) {
          this.calculateConvenienceFee();
        }
      }
    }, err => {
    });
    this.subscriptions.push(sub);
  }

  private applyRentalRenewalAvailability() {
    if (this.allowMonthlyRentalRenewal === false) {
      (this.selectedMonthlyBooths ?? [])
        .filter(record => record.BookingCanExtend !== false)
        .forEach(record => {
          record.BookingCanExtend = false;
          record.RenewalStartMonth = "This booking cannot be extended further!";
        });
    }
    if (this.allowWeeklyRentalRenewal === false) {
      (this.selectedWeeklyBooths ?? [])
        .filter(record => record.BookingCanExtend !== false)
        .forEach(record => {
          record.BookingCanExtend = false;
          record.RenewalStartWeek = "This booking cannot be extended further!";
        });
    }
  }

  calculateConvenienceFee() {
    var convenienceFee = 0;
    var creditCardAmount = this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentAmount').value);
    var totalrentalCharge = this.getActualAmountFromInp(this.bookingDetailsForm.get('rentalCharge').value);
    var otherRentalCharge = this.getActualAmountFromInp(this.bookingDetailsForm.get('otherCharge').value);
    var totalSalesTax = this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSalesTax').value);
    var totalSecondLeveltax = this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSecondLeveltax').value);
    var vendorLateFee = this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentLateFee').value ?? 0);
    var renewalFee = this.getActualAmountFromInp(this.bookingDetailsForm.get('additionalCharge').value);
    var totalDue = this.actualTotalDue + totalrentalCharge + otherRentalCharge + totalSalesTax + totalSecondLeveltax + vendorLateFee;
    if(totalDue > 0){
      totalDue = totalDue + renewalFee;
    }
    else{
      renewalFee = 0;
    }
    if (creditCardAmount > 0) {
      var convenienceFee = creditCardAmount * ((this.CcfeeinPercentage) / 100);

      if (this.CCFeeType == 1) {
        convenienceFee = this.CcfeeinPercentage;
      }

      if (this.FirstMondayCustomChanges && creditCardAmount < 100) {
        convenienceFee = 3;
      }
      totalDue += convenienceFee;
      this.creditCardAmount = creditCardAmount + convenienceFee;
    }
    var totalAmount = 0;
    totalAmount = creditCardAmount + convenienceFee;
    const balanceAmount = totalDue - totalAmount;

    this.bookingDetailsForm.patchValue({
      convenienceFee: this.customCurrency.transform(convenienceFee.toString()),
      balanceDue: this.customCurrency.transform(balanceAmount.toString()),
      totalPayment: this.customCurrency.transform(totalAmount.toString()),
      totalCharge: this.customCurrency.transform(totalDue.toString())
    }, { emitEvent: false })
    this.paymentAmount = this.getActualAmountFromInp(this.bookingDetailsForm.get('totalPayment').value);
  }

  // Vendor's saved resale info for this market (same source as the other rent-online screens).
  private applyMarketVendorSettings(res: any) {
    const response = res?.body;
    if (response) {
      this.exemptResale = response.ExemptResale;
      this.resaleNo = response.Resale ?? "";
    }
  }

  // Called from getMonthlyMarketDays after companyId is set (company-specific overrides below).
  private applyRentalPaymentSettings(res: any) {
    this.ResaleNumberRequired = this.companyId == 53 ? false : res.ResaleNumberRequired;
    this.DaysSellWithoutResaleNumber = res.DaysSellWithoutResaleNumber;
    this.BusinessLicenseNumberRequired = this.companyId == 53 ? false : res.BusinessLicenseNumberRequired;
    this.DaysSellWithoutBusiLicNumber = res.DaysSellWithoutBusiLicNumber;
    this.MonthlyBookingEndDate = res.MonthlyBookingEndDate;
    this.masterRentChargeforResOtherItems = res.MasterChargeForOtherChargeRenewal;
    this.secondTaxName = res.SecondTaxName ? res.SecondTaxName: "Sec Level Tax";
    this.displayCityTax = res.RentalSecondTaxable;
    this.displaySalesTax = res.RentalTaxable;
  }

  updateRentalRecord(record) {
    if (record.Reservation && this.allowMonthlyRentalRenewal) {
      const rentEndPeriodIndex = this.monthlyMarketDays.findIndex(e => e.RentalMonths == record.RentEndPeriod);
      var renewalStartMonth = this.monthlyMarketDays[rentEndPeriodIndex + 1].RentalMonths
      if (record.Status == "R") {
        renewalStartMonth = this.monthlyMarketDays[rentEndPeriodIndex].RentalMonths
      }

      record.BookingCanExtend = true;
      record.RenewalStartMonth =renewalStartMonth
      record.MonthlyRenewalMonth = renewalStartMonth;
      record.RentEndPeriodIndex = rentEndPeriodIndex
      if (this.UnchkBoothOnOthChgRemoval) {
        record.Recurring = true;
        this.selectedOtherItems
          .filter(e => e.BoothNo === record.BoothNumber && e.BoothNo != "none")
          .forEach(othrental => {
            othrental.Recurring = true;
          })
      }
      this.extendMonthlyRental(record);
      this.applyOnlineBookingFeeIfNeeded();
    }
    else{
      record.BookingCanExtend = false;
      record.RenewalStartMonth = "This booking cannot be extended further!";
      record.MonthlyRenewalMonth = record.RentalMonth;
      record.RentEndPeriod = record.CurrentRentEndPeriod;
      this.totalRentalCharge -= this.getActualAmountFromInp(record.Rent);
      this.totalSalesTax -= this.getActualAmountFromInp(record.SalesTax);
      this.totalSecondLeveltax -= this.getActualAmountFromInp(record.CityTax);
      this.updateCharges();
      record.Rent = this.customCurrency.transform("0");
      record.CityTax = this.customCurrency.transform("0");

      if (this.UnchkBoothOnOthChgRemoval) {
        this.selectedOtherItems
          .filter(e => e.BoothNo === record.BoothNumber && e.BoothNo != "none")
          .forEach(othrental => {
            othrental.Recurring = false;
            othrental.BookingCanExtend = false;
            othrental.RenewalStartWeek = "This booking cannot be extended further!";
            othrental.MonthlyRenewalMonth = record.RentalMonth;
            this.totalOtherRentalCharge -= this.getActualAmountFromInp(othrental.OtherItemtotal);
            this.totalSalesTax -= this.getActualAmountFromInp(othrental.SalesTax);
            this.totalSecondLeveltax -= this.getActualAmountFromInp(othrental.CityTax);
            this.updateCharges();
            othrental.OtherItemtotal = this.customCurrency.transform("0");
            othrental.Quantity = 0;
            othrental.OtherItemCharge = this.customCurrency.transform("0");
          });
        // Patch form
        this.updateCharges();
      }
      this.applyOnlineBookingFeeIfNeeded();
    }
  }

  async extendMonthlyRental(extendRentalRecord: any) {
    const extendedRentalEndDates = extendRentalRecord.MonthlyRenewalMonth;

    if (extendedRentalEndDates != extendRentalRecord.CurrentRentStartPeriod) {
      const result = await Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Are you sure you wish to extend the bookings till ` + extendedRentalEndDates + '? Please note that the extended period cannot be cancelled',
        icon: "question",
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,
      });
      if (!result.isConfirmed) {
        const recordExist = extendRentalRecord.MonthlyRentalId != 0
          ? this.selectedMonthlyBooths.findIndex(e =>
            e.RentStartPeriod == extendRentalRecord.RentStartPeriod &&
            e.RentEndPeriod == extendRentalRecord.RentEndPeriod &&
            e.BoothNumber == extendRentalRecord.BoothNumber &&
            e.MonthlyRentalId == extendRentalRecord.MonthlyRentalId)
          : this.selectedMonthlyBooths.findIndex(e =>
            e.RentStartPeriod == extendRentalRecord.RentStartPeriod &&
            e.RentEndPeriod == extendRentalRecord.RentEndPeriod &&
            e.BoothNumber == extendRentalRecord.BoothNumber &&
            e.RentalMarketDay == extendRentalRecord.RentalMarketDay);

        if (recordExist !== -1) {
          const record = this.selectedMonthlyBooths[recordExist];
          record.MonthlyRenewalMonth = extendRentalRecord.RentEndPeriod;
          return
        };
      }
    }

    this.loaderIcon = Promise.resolve(true);
    if ((this.ResaleNumberRequired && !this.exemptResale) || this.BusinessLicenseNumberRequired) {
      await this.handleResaleOrLicenseCheck(extendRentalRecord);
    } else {
      await this.proceedExtendingRental(extendRentalRecord);
    }
  }

  private async handleResaleOrLicenseCheck(extendRentalRecord: any) {
    const dateSet = new Set<string>();
    let vendorRentalDays: any[] = [];
    let marketDayCountForResale = 0;

    const boothDays = (booth: any) => this.getBoothMarketDays(booth).map(d => d - 1);

    const selectedBoothRecord = this.selectedMonthlyBooths.filter(e => e.NewBooth || e.ExtendRental);
    let rentalDates: string[] = [];

    for (const record of selectedBoothRecord) {
      rentalDates.push(...this.generateDates(new Date(record.RentalStartDate), new Date(record.RentalEndDate), boothDays(record)));
    }

    const recordExist = this.selectedMonthlyBooths.findIndex(e =>
      e.RentStartPeriod == extendRentalRecord.RentStartPeriod &&
      e.RentEndPeriod == extendRentalRecord.RentEndPeriod &&
      e.BoothNumber == extendRentalRecord.BoothNumber &&
      (extendRentalRecord.MonthlyRentalId == 0 || e.MonthlyRentalId == extendRentalRecord.MonthlyRentalId)
    );

    if (recordExist !== -1) {
      const record = this.selectedMonthlyBooths[recordExist];
      const startDate = new Date(record.RentalStartDate);
      const [endMonthDate, endMonthYear] = extendRentalRecord.MonthlyRenewalMonth.split(' ');
      const endMonthIndex = this.getMonthIndex(endMonthDate);
      let endDate = new Date(endMonthYear, endMonthIndex + 1, 0);

      if (this.MonthlyBookingEndDate) {
        const ym = `${endDate.getFullYear()}${(endDate.getMonth() + 1).toString().padStart(2, '0')}`;
        endDate = await this.getMonthEndingDateFromSetting(ym);
      }

      rentalDates.push(...this.generateDates(startDate, endDate, boothDays(record)));
    }

    for (const date of rentalDates) {
      if (!dateSet.has(date)) {
        dateSet.add(date);
        vendorRentalDays.push({ VendorRentalDate: date });
        marketDayCountForResale++;
        if (marketDayCountForResale > this.DaysSellWithoutResaleNumber) break;
      }
    }

    const vendorRentalDaysRes = await this.getVendorRentalDays();

    if (vendorRentalDaysRes?.length) {
      for (const el of vendorRentalDaysRes) {
        const formatted = this.datePipe.transform(el.VendorRentalDate, 'MM/dd/yyyy');
        if (!dateSet.has(formatted)) {
          dateSet.add(formatted);
          vendorRentalDays.push({ VendorRentalDate: formatted });
          marketDayCountForResale++;
        }
      }
    }

    if (this.ResaleNumberRequired && !this.exemptResale && !this.resaleNo &&
      marketDayCountForResale > this.DaysSellWithoutResaleNumber && !this.resaleOptionSelected) {
      this.resaleModalFlow = {
        resume: () => this.handleResaleOrLicenseCheck(extendRentalRecord),
        cancel: () => {
          extendRentalRecord.Reservation = false;
          this.updateRentalRecord(extendRentalRecord);
        }
      };
      const modal = this.modalResaleNo.nativeElement;
      modal.classList.add('show');
      modal.style.display = 'block';
      this.loaderIcon = Promise.resolve(false);
    } else if (this.BusinessLicenseNumberRequired && marketDayCountForResale > this.DaysSellWithoutBusiLicNumber) {
      await this.handleBusinessLicenseFlow(extendRentalRecord);
    } else {
      await this.proceedExtendingRental(extendRentalRecord);
    }
  }

  private generateDates(start: Date, end: Date, selectedDays: number[]): string[] {
    const dates: string[] = [];
    let current = new Date(start);
    while (current <= end) {
      if (selectedDays.includes(current.getDay())) {
        dates.push(this.datePipe.transform(current, 'MM/dd/yyyy'));
      }
      current.setDate(current.getDate() + 1);
    }
    return dates;
  }

  async handleBusinessLicenseFlow(extendRentalRecord: any) {
    if (!this.businessLicenseNumber) {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Business License is required! Please contact the market`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
      this.loaderIcon = Promise.resolve(false);
      this.revertMonthlyRentalExtension(extendRentalRecord);
      return;
    }

    if (!this.businessLicenseExpiryDate) {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Business License is expired! Please contact the market`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
      this.loaderIcon = Promise.resolve(false);
      this.revertMonthlyRentalExtension(extendRentalRecord);
      return;
    }

    if (new Date(this.businessLicenseExpiryDate) < new Date()) {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Business License is expired! Please contact the market`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
      this.loaderIcon = Promise.resolve(false);
      this.revertMonthlyRentalExtension(extendRentalRecord);
      return;
    }

    await this.proceedExtendingRental(extendRentalRecord);
  }

  // Undo an in-progress CM (Monthly) extension attempt (dropdown selection)
  // so the record does not appear extended when the extension was blocked.
  private revertMonthlyRentalExtension(extendRentalRecord: any) {
    const recordExist = extendRentalRecord.MonthlyRentalId != 0
      ? this.selectedMonthlyBooths.findIndex(e =>
        e.RentStartPeriod == extendRentalRecord.RentStartPeriod &&
        e.RentEndPeriod == extendRentalRecord.RentEndPeriod &&
        e.BoothNumber == extendRentalRecord.BoothNumber &&
        e.MonthlyRentalId == extendRentalRecord.MonthlyRentalId)
      : this.selectedMonthlyBooths.findIndex(e =>
        e.RentStartPeriod == extendRentalRecord.RentStartPeriod &&
        e.RentEndPeriod == extendRentalRecord.RentEndPeriod &&
        e.BoothNumber == extendRentalRecord.BoothNumber &&
        e.RentalMarketDay == extendRentalRecord.RentalMarketDay);

    if (recordExist !== -1) {
      const record = this.selectedMonthlyBooths[recordExist];
      record.MonthlyRenewalMonth = extendRentalRecord.RentEndPeriod;
    }
  }

  async proceedExtendingRental(extendRentalRecord: any) {
    this.loaderIcon = Promise.resolve(true);
    const recordExist = extendRentalRecord.MonthlyRentalId != 0
      ? this.selectedMonthlyBooths.findIndex(e =>
        e.RentStartPeriod == extendRentalRecord.RentStartPeriod &&
        e.RentEndPeriod == extendRentalRecord.RentEndPeriod &&
        e.BoothNumber == extendRentalRecord.BoothNumber &&
        e.MonthlyRentalId == extendRentalRecord.MonthlyRentalId)
      : this.selectedMonthlyBooths.findIndex(e =>
        e.RentStartPeriod == extendRentalRecord.RentStartPeriod &&
        e.RentEndPeriod == extendRentalRecord.RentEndPeriod &&
        e.BoothNumber == extendRentalRecord.BoothNumber &&
        e.RentalMarketDay == extendRentalRecord.RentalMarketDay);

    if (recordExist === -1) return;

    const booth = this.selectedMonthlyBooths[recordExist];

    if (booth.Drop || !booth.Reservation || !this.allowMonthlyRentalRenewal) {
      booth.MonthlyRenewalMonth = booth.RentEndPeriod;
      booth.RenewalStartMonth = "This booking cannot be extended further!";
      booth.BookingCanExtend = false;
      this.loaderIcon = Promise.resolve(false);
      return;
    }

    const rentalDates: any[] = [];
    let currentMonthRentalDates: any[] = [];
    let rentalstartDate: string;
    let marketDays = 0;

    const daysMap = [
      { key: 'Sunday', label: 'Sun', value: 0 },
      { key: 'Monday', label: 'Mon', value: 1 },
      { key: 'Tuesday', label: 'Tue', value: 2 },
      { key: 'Wednesday', label: 'Wed', value: 3 },
      { key: 'Thursday', label: 'Thu', value: 4 },
      { key: 'Friday', label: 'Fri', value: 5 },
      { key: 'Saturday', label: 'Sat', value: 6 }
    ];

    const selectedDay = daysMap.find(d => booth[d.key]);
    const marketDay = selectedDay?.label;
    const selectedDayOfWeek = selectedDay?.value;

    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYearMonth = `${currentDate.getFullYear()}${currentMonth < 10 ? '0' : ''}${currentMonth}`;

    let startDate = new Date(booth.RentalStartDate);
    const [endMonthDate, endMonthYear] = extendRentalRecord.MonthlyRenewalMonth.split(' ');
    const endMonthIndex = this.getMonthIndex(endMonthDate);
    let endDate = new Date(endMonthYear, endMonthIndex + 1, 0);
    let endDateYearMonth: string;

    if (this.MonthlyBookingEndDate) {
      const rentalEndDateMonth = endDate.getMonth() + 1;
      const rentalEndDateYearMonth = `${endDate.getFullYear()}${rentalEndDateMonth < 10 ? '0' : ''}${rentalEndDateMonth}`;
      endDate = await this.getMonthEndingDateFromSetting(rentalEndDateYearMonth);
      endDateYearMonth = rentalEndDateYearMonth;

      const rentalStartDate = new Date(startDate);
      const previousMonthDate = new Date(rentalStartDate.setMonth(rentalStartDate.getMonth() - 1));
      const previousMonth = previousMonthDate.getMonth() + 1;
      const previousMonthYear = previousMonthDate.getFullYear();
      const previousMonthYearAndMonth = `${previousMonthYear}${previousMonth < 10 ? '0' : ''}${previousMonth}`;

      const monthEndDate = await this.getMonthEndingDateFromSetting(previousMonthYearAndMonth);
      const dateDiff = this.getDaysDifference(monthEndDate, new Date(startDate));

      if (dateDiff <= 7 && new Date(monthEndDate) < startDate) {
        startDate = new Date() > new Date(monthEndDate) ? new Date() : new Date(monthEndDate.setDate(monthEndDate.getDate() + 1));
      }
    }

    let currentMonthEnd = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);

    if (this.MonthlyBookingEndDate) {
      const [startMonthDate, startMonthYear] = booth.RentStartPeriod.split(' ');
      const startMonthIndex = this.getMonthIndex(startMonthDate);
      currentMonthEnd = new Date(startMonthYear, startMonthIndex + 1, 0);
      const rentalEndDateMonth = currentMonthEnd.getMonth() + 1;
      const rentalEndDateYearMonth = `${currentMonthEnd.getFullYear()}${rentalEndDateMonth < 10 ? '0' : ''}${rentalEndDateMonth}`;

      if (endDateYearMonth == rentalEndDateYearMonth) {
        currentMonthEnd = await this.getMonthEndingDateFromSetting(rentalEndDateYearMonth);
      }
    }

    const compareDates = (a: DateString, b: DateString): number =>
      new Date(a.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime() -
      new Date(b.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();

    let currentDay = new Date(startDate);
    while (currentDay <= endDate) {
      if (currentDay.getDay() === selectedDayOfWeek) {
        if (!rentalstartDate) rentalstartDate = this.datePipe.transform(new Date(currentDay), 'MMM d, y');
        marketDays++;
        rentalDates.push({ startDate: this.datePipe.transform(new Date(currentDay), 'MMM d, y') });
      }
      currentDay.setDate(currentDay.getDate() + 1);
    }

    if (this.MonthlyBookingEndDate) {
      currentDay = new Date(startDate);
      while (currentDay <= currentMonthEnd) {
        if (currentDay.getDay() === selectedDayOfWeek) {
          if (!rentalstartDate) rentalstartDate = this.datePipe.transform(new Date(currentDay), 'MMM d, y');
          currentMonthRentalDates.push({ startDate: this.datePipe.transform(new Date(currentDay), 'MMM d, y') });
        }
        currentDay.setDate(currentDay.getDate() + 1);
      }
      currentMonthRentalDates.sort(compareDates);
    } else {
      currentMonthRentalDates = rentalDates;
    }

    rentalDates.sort(compareDates);

    const allRentalDates = rentalDates.map(el => new Date(el.startDate));
    const currentRentedEndDate = new Date(booth.RentalEndDate);
    const filteredRentalDates = allRentalDates.filter(rentalDate => rentalDate > currentRentedEndDate);

    let extendRentalStartPeriod: any;
    if (!booth.NewBooth && booth.Status != "R") {
      extendRentalStartPeriod = new Date(booth.RentalSavedEndDate);
      if (extendRentalStartPeriod.getDate() == 31) {
        extendRentalStartPeriod.setDate(extendRentalStartPeriod.getDate() + 1);
      }
      else {
        extendRentalStartPeriod.setMonth(extendRentalStartPeriod.getMonth() + 1);
      }
      extendRentalStartPeriod.setDate(1);
    } else {
      extendRentalStartPeriod = booth.RentalStartDate;
    }

    const chargeObj = {
      BoothTypeId: booth.BoothTypeId,
      VendorId: this.vendorId,
      RentalStartPeriod: new Date(extendRentalStartPeriod),
      RentalEndPeriod: new Date(rentalDates[rentalDates.length - 1].startDate),
      PerDiemApplicable: booth.PerDiem,
      RentalMarketDay: marketDay,
      JanRent: this.getActualAmountFromInp(booth.January ?? 0),
      FebRent: this.getActualAmountFromInp(booth.February ?? 0),
      MarRent: this.getActualAmountFromInp(booth.March ?? 0),
      AprRent: this.getActualAmountFromInp(booth.April ?? 0),
      MayRent: this.getActualAmountFromInp(booth.May ?? 0),
      JunRent: this.getActualAmountFromInp(booth.June ?? 0),
      JulRent: this.getActualAmountFromInp(booth.July ?? 0),
      AugRent: this.getActualAmountFromInp(booth.August ?? 0),
      SepRent: this.getActualAmountFromInp(booth.September ?? 0),
      OctRent: this.getActualAmountFromInp(booth.October ?? 0),
      NovRent: this.getActualAmountFromInp(booth.November ?? 0),
      DecRent: this.getActualAmountFromInp(booth.December ?? 0),
    };

    // The availability check and the charge lookup are independent, so request both together
    // (the charges are simply ignored when the booth is not available).
    const chargesRequest = lastValueFrom(this.rentalService.getBoothRentalMontlyCharges(this.marketId, chargeObj));
    chargesRequest.catch(() => { }); // surfaced below when the charges are used

    const rentalExistsRes = await lastValueFrom(
      this.rentalService.checkRentalExits(this.marketId, {
        RentalDates: filteredRentalDates,
        BoothNumber: booth.BoothNumber
      })
    );

    if (rentalExistsRes.Success) {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Rental End Period cannot be extended further`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
      return;
    }

    this.totalRentalCharge -= this.getActualAmountFromInp(booth.Rent);
    this.totalSalesTax -= this.getActualAmountFromInp(booth.SalesTax);
    this.totalSecondLeveltax -= this.getActualAmountFromInp(booth.CityTax);
    this.updateCharges();

    const res = await chargesRequest;

    if (!res) return;

    Object.assign(booth, {
      RentEndPeriod: extendRentalRecord.MonthlyRenewalMonth,
      RentalEndDate: this.datePipe.transform(new Date(rentalDates[rentalDates.length - 1].startDate), 'MMM d, y'),
      MktDays: marketDays,
      Rent: this.customCurrency.transform(res.Rent),
      SalesTax: this.customCurrency.transform(res.SalesTax),
      CityTax: this.customCurrency.transform(res.CityTax),
      January: this.customCurrency.transform(res.JanRent),
      February: this.customCurrency.transform(res.FebRent),
      March: this.customCurrency.transform(res.MarRent),
      April: this.customCurrency.transform(res.AprRent),
      May: this.customCurrency.transform(res.MayRent),
      June: this.customCurrency.transform(res.JunRent),
      July: this.customCurrency.transform(res.JulRent),
      August: this.customCurrency.transform(res.AugRent),
      September: this.customCurrency.transform(res.SepRent),
      October: this.customCurrency.transform(res.OctRent),
      November: this.customCurrency.transform(res.NovRent),
      December: this.customCurrency.transform(res.DecRent),
      JanuaryMonthPresent: res.JanuaryMonthPresent,
      FebruaryMonthPresent: res.FebruaryMonthPresent,
      MarchMonthPresent: res.MarchMonthPresent,
      AprilMonthPresent: res.AprilMonthPresent,
      MayMonthPresent: res.MayMonthPresent,
      JuneMonthPresent: res.JuneMonthPresent,
      JulyMonthPresent: res.JulyMonthPresent,
      AugustMonthPresent: res.AugustMonthPresent,
      SeptemberMonthPresent: res.SeptemberMonthPresent,
      OctoberMonthPresent: res.OctoberMonthPresent,
      NovemberMonthPresent: res.NovemberMonthPresent,
      DecemberMonthPresent: res.DecemberMonthPresent,
      DisableJanMonth: !res.JanRent && res.JanRent !== 0,
      DisableFebMonth: !res.FebRent && res.FebRent !== 0,
      DisableMarMonth: !res.MarRent && res.MarRent !== 0,
      DisableAprMonth: !res.AprRent && res.AprRent !== 0,
      DisableMayMonth: !res.MayRent && res.MayRent !== 0,
      DisableJunMonth: !res.JunRent && res.JunRent !== 0,
      DisableJulMonth: !res.JulRent && res.JulRent !== 0,
      DisableAugMonth: !res.AugRent && res.AugRent !== 0,
      DisableSepMonth: !res.SepRent && res.SepRent !== 0,
      DisableOctMonth: !res.OctRent && res.OctRent !== 0,
      DisableNovMonth: !res.NovRent && res.NovRent !== 0,
      DisableDecMonth: !res.DecRent && res.DecRent !== 0,
      StartDateList: currentMonthRentalDates,
      ExtendRental: true,
      AllRentalDates: rentalDates.map(el => new Date(el.startDate))
    });

    this.totalRentalCharge += this.getActualAmountFromInp(res.Rent);
    this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
    this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
    this.updateCharges();
    this.loaderIcon = Promise.resolve(false);
    if (this.UnchkBoothOnOthChgRemoval) {
      this.selectedOtherItems
        .filter(e => e.BoothNo === booth.BoothNumber && e.BoothNo != "none")
        .forEach(othrental => {
          if (othrental.Recurring) {
            this.updateMonthlytherItemRecord(othrental, extendRentalRecord.MonthlyRenewalMonth);
          }
        });
    }
  }

  closeResaleModal(){
    // this.refreshAddBooth();
    const modal = this.modalResaleNo.nativeElement;
    if (modal.classList.contains('show')) {
      modal.style.display = 'none';
      modal.classList.remove('show');
    }
  }

  async validateResaleAndBusinessLicense() {
    if (!this.resaleNo || this.resaleNo.trim() === '') {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Enter the resale number`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
      return;
    }

    this.resaleOptionSelected = true;
    this.closeResaleModal();

    const obj = {
      VendorID: this.vendorId,
      ExemptResaleNo: false,
      ExemptResaleReason: "",
      ResaleNo: this.resaleNo,
      MarketId: this.marketId
    }
    this.subscriptions.push(this.rentalService.UpdateVendorResaleInfo(obj).subscribe((res: any) => {
    }));

    // Re-run the check that opened the modal; with the resale number set it moves on to the
    // business license check (if required) and then renews/extends the booths.
    const flow = this.resaleModalFlow;
    this.resaleModalFlow = null;
    if (flow) {
      await flow.resume();
    }
  }

  // Popup closed (X) without a resale number: do not renew/extend, undo the pending selection.
  dismissResaleModal() {
    this.closeResaleModal();
    // Drop anything typed but not confirmed with OK; otherwise the next check sees a resale
    // number and skips the popup, extending with a number that was never validated or saved.
    this.resaleNo = "";
    this.loaderIcon = Promise.resolve(false);
    const flow = this.resaleModalFlow;
    this.resaleModalFlow = null;
    if (flow) {
      flow.cancel();
    }
  }

  getWeeklyRental() {
    this.loaderIcon = Promise.resolve(true);
    this.selectedWeeklyBooths = [];
    var existingBooths = [];
    const sub = this.rentalService.getWeeklyBookings(this.marketId,this.vendorId).subscribe((res: any[]) => {
      if (res) {
        existingBooths = res;
        existingBooths.forEach((el) => {
          var marketDay;
          if (el.Sunday) {
            marketDay = 'Sun'
          }
          else if (el.Monday) {
            marketDay = 'Mon'
          }
          else if (el.Tuesday) {
            marketDay = 'Tue'
          }
          else if (el.Wednesday) {
            marketDay = 'Wed'
          }
          else if (el.Thursday) {
            marketDay = 'Thu'
          }
          else if (el.Friday) {
            marketDay = 'Fri'
          }
          else if (el.Saturday) {
            marketDay = 'Sat'
          }

          if (el.Status == "R") {
            const rentEndPeriodIndex = this.weeklyMarketDays.findIndex(e=>e.RentalEndDays == rentalEndDate);
            const renewalStartWeek = this.weeklyMarketDays[rentEndPeriodIndex +1].RentalEndDays
            var obj = {
              BoothTypeId: el.BoothTypeId,
              VendorId: this.vendorId,
              RentalStartPeriod: new Date(this.weeklyMarketDays[0].RentalEndDays.split('-')[0]),
              RentalEndPeriod: new Date(this.weeklyMarketDays[0].RentalEndDays.split('-')[1]),
              RentalMarketDay: marketDay
            }
            this.rentalService.getBoothRentalWeeklyCharges(this.marketId,obj).subscribe((res: any) => {
              const ob = {
                WeeklyRentalId: el.WeeklyRentalId,
                BoothNumber: el.BoothNumber,
                BoothType: el.BoothType,
                BoothTypeId: el.BoothTypeId,
                RentStartPeriod: this.weeklyMarketDays[0].RentalEndDays,
                CurrentRentStartPeriod: this.weeklyMarketDays[0].RentalEndDays,
                RentEndPeriod: this.weeklyMarketDays[0].RentalEndDays,
                CurrentRentEndPeriod: this.weeklyMarketDays[0].RentalEndDays,
                RentalSavedEndDate: this.weeklyMarketDays[0].RentalEndDays.split('-')[1],
                Product: el.ProductId,
                ProductName: this.vendorProducts.filter(e=>e.ProductId == el.ProductId)[0]?.ProductName,
                Rent: this.customCurrency.transform(res.Rent),
                SalesTax: this.customCurrency.transform(res.SalesTax),
                CityTax: this.customCurrency.transform(res.CityTax),
                CurrentRent: this.customCurrency.transform(el.RentalCharge),
                CurrentSalesTax: this.customCurrency.transform(el.SalesTax),
                CurrentSecondTax: this.customCurrency.transform(el.SecLevelTax),
                Sunday: el.Sunday,
                Monday: el.Monday,
                Tuesday: el.Tuesday,
                Wednesday: el.Wednesday,
                Thursday: el.Thursday,
                Friday: el.Friday,
                Saturday: el.Saturday,
                Reservation: el.BoothReserved,
                WeekDay: marketDay,
                Drop: el.DoNotRenew,
                January: this.customCurrency.transform(res.JanRent),
                February: this.customCurrency.transform(res.FebRent),
                March: this.customCurrency.transform(res.MarRent),
                April: this.customCurrency.transform(res.AprRent),
                May: this.customCurrency.transform(res.MayRent),
                June: this.customCurrency.transform(res.JunRent),
                July: this.customCurrency.transform(res.JulRent),
                August: this.customCurrency.transform(res.AugRent),
                September: this.customCurrency.transform(res.SepRent),
                October: this.customCurrency.transform(res.OctRent),
                November: this.customCurrency.transform(res.NovRent),
                December: this.customCurrency.transform(res.DecRent),
                JanuaryMonthPresent: res.JanuaryMonthPresent,
                FebruaryMonthPresent: res.FebruaryMonthPresent,
                MarchMonthPresent: res.MarchMonthPresent,
                AprilMonthPresent: res.AprilMonthPresent,
                MayMonthPresent: res.MayMonthPresent,
                JuneMonthPresent: res.JuneMonthPresent,
                JulyMonthPresent: res.JulyMonthPresent,
                AugustMonthPresent: res.AugustMonthPresent,
                SeptemberMonthPresent: res.SeptemberMonthPresent,
                OctoberMonthPresent: res.OctoberMonthPresent,
                NovemberMonthPresent: res.NovemberMonthPresent,
                DecemberMonthPresent: res.DecemberMonthPresent,
                DisableJanMonth: res.JanRent ? false : true,
                DisableFebMonth: res.FebRent ? false : true,
                DisableMarMonth: res.MarRent ? false : true,
                DisableAprMonth: res.AprRent ? false : true,
                DisableMayMonth: res.MayRent ? false : true,
                DisableJunMonth: res.JunRent ? false : true,
                DisableJulMonth: res.JulRent ? false : true,
                DisableAugMonth: res.AugRent ? false : true,
                DisableSepMonth: res.SepRent ? false : true,
                DisableOctMonth: res.OctRent ? false : true,
                DisableNovMonth: res.NovRent ? false : true,
                DisableDecMonth: res.DecRent ? false : true,
                Status: el.Status,
                NewBooth: false,
                BookingCanExtend: true,
                RenewalStartWeek:renewalStartWeek,
                CWRenewalWeek:this.weeklyMarketDays[rentEndPeriodIndex +1].RentalEndDays,
                RentEndPeriodIndex:rentEndPeriodIndex
              }
              this.totalRentalCharge += this.getActualAmountFromInp(res.Rent);
              this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
              this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
              this.updateCharges();
              this.selectedWeeklyBooths.push(ob);
            });
          }
          else {
            var JanuaryMonthPresent = false;
            var FebruaryMonthPresent = false;
            var MarchMonthPresent = false;
            var AprilMonthPresent = false;
            var MayMonthPresent = false;
            var JuneMonthPresent = false;
            var JulyMonthPresent = false;
            var AugustMonthPresent = false;
            var SeptemberMonthPresent = false;
            var OctoberMonthPresent = false;
            var NovemberMonthPresent = false;
            var DecemberMonthPresent = false;

            var rentalStartDateRecord = this.weeklyMarketDays.filter(date => this.datePipe.transform(new Date(date.RentalStartDays.split('-')[0]), 'MM/dd/yyyy') <= this.datePipe.transform(new Date(el.RentalStartDate), 'MM/dd/yyyy')
              && this.datePipe.transform(new Date(date.RentalStartDays.split('-')[1]), 'MM/dd/yyyy') >= this.datePipe.transform(new Date(el.RentalStartDate), 'MM/dd/yyyy'))
            if (rentalStartDateRecord.length > 0)
              var rentalStartDate = rentalStartDateRecord[0].RentalStartDays;

            var rentalEndDateRecord = this.weeklyMarketDays.filter(date => this.datePipe.transform(new Date(date.RentalEndDays.split('-')[0]), 'MM/dd/yyyy') <= this.datePipe.transform(new Date(el.RentalEndDate), 'MM/dd/yyyy')
              && this.datePipe.transform(new Date(date.RentalEndDays.split('-')[1]), 'MM/dd/yyyy') >= this.datePipe.transform(new Date(el.RentalEndDate), 'MM/dd/yyyy'))
            if (rentalEndDateRecord.length > 0)
              var rentalEndDate = rentalEndDateRecord[0].RentalEndDays;

            const rentEndPeriodIndex = this.weeklyMarketDays.findIndex(e=>e.RentalEndDays == rentalEndDate);
            const renewalStartWeek = this.weeklyMarketDays[rentEndPeriodIndex +1].RentalEndDays

            if (rentalStartDate && rentalEndDate) {
              var month = this.datePipe.transform(rentalEndDate.split('-')[1], 'MMM');
              switch (month.toLowerCase()) {
                case "jan":
                  JanuaryMonthPresent = true;
                  break;
                case "feb":
                  FebruaryMonthPresent = true;
                  break;
                case "mar":
                  MarchMonthPresent = true;
                  break;
                case "apr":
                  AprilMonthPresent = true;
                  break;
                case "may":
                  MayMonthPresent = true;
                  break;
                case "jun":
                  JuneMonthPresent = true;
                  break;
                case "jul":
                  JulyMonthPresent = true;
                  break;
                case "aug":
                  AugustMonthPresent = true;
                  break;
                case "sep":
                  SeptemberMonthPresent = true;
                  break;
                case "oct":
                  OctoberMonthPresent = true;
                  break;
                case "nov":
                  NovemberMonthPresent = true;
                  break;
                case "dec":
                  DecemberMonthPresent = true;
                  break;
              }

              const ob = {
                WeeklyRentalId: el.WeeklyRentalId,
                BoothNumber: el.BoothNumber,
                BoothType: el.BoothType,
                BoothTypeId: el.BoothTypeId,
                RentStartPeriod: rentalStartDate,
                RentEndPeriod: rentalEndDate,
                CurrentRentStartPeriod: this.weeklyMarketDays[0].RentalEndDays,
                CurrentRentEndPeriod: this.weeklyMarketDays[0].RentalEndDays,
                RentalSavedEndDate: rentalEndDate,
                Product: el.ProductId,
                ProductName: this.vendorProducts.filter(e=>e.ProductId == el.ProductId)[0]?.ProductName,
                Rent: this.customCurrency.transform('0.00'),
                SalesTax: this.customCurrency.transform('0.00'),
                CityTax: this.customCurrency.transform('0.00'),
                CurrentRent: this.customCurrency.transform(el.RentalCharge),
                CurrentSalesTax: this.customCurrency.transform(el.SalesTax),
                CurrentSecondTax: this.customCurrency.transform(el.SecLevelTax),
                Sunday: el.Sunday,
                Monday: el.Monday,
                Tuesday: el.Tuesday,
                Wednesday: el.Wednesday,
                Thursday: el.Thursday,
                Friday: el.Friday,
                Saturday: el.Saturday,
                WeekDay: marketDay,
                Reservation: el.BoothReserved,
                Drop: el.DoNotRenew,
                January: this.customCurrency.transform('0.00'),
                February: this.customCurrency.transform('0.00'),
                March: this.customCurrency.transform('0.00'),
                April: this.customCurrency.transform('0.00'),
                May: this.customCurrency.transform('0.00'),
                June: this.customCurrency.transform('0.00'),
                July: this.customCurrency.transform('0.00'),
                August: this.customCurrency.transform('0.00'),
                September: this.customCurrency.transform('0.00'),
                October: this.customCurrency.transform('0.00'),
                November: this.customCurrency.transform('0.00'),
                December: this.customCurrency.transform('0.00'),
                NewBooth: false,
                JanuaryMonthPresent: JanuaryMonthPresent,
                FebruaryMonthPresent: FebruaryMonthPresent,
                MarchMonthPresent: MarchMonthPresent,
                AprilMonthPresent: AprilMonthPresent,
                MayMonthPresent: MayMonthPresent,
                JuneMonthPresent: JuneMonthPresent,
                JulyMonthPresent: JulyMonthPresent,
                AugustMonthPresent: AugustMonthPresent,
                SeptemberMonthPresent: SeptemberMonthPresent,
                OctoberMonthPresent: OctoberMonthPresent,
                NovemberMonthPresent: NovemberMonthPresent,
                DecemberMonthPresent: DecemberMonthPresent,
                DisableJanMonth: true,
                DisableFebMonth: true,
                DisableMarMonth: true,
                DisableAprMonth: true,
                DisableMayMonth: true,
                DisableJunMonth: true,
                DisableJulMonth: true,
                DisableAugMonth: true,
                DisableSepMonth: true,
                DisableOctMonth: true,
                DisableNovMonth: true,
                DisableDecMonth: true,
                BookingCanExtend: true,
                RenewalStartWeek:renewalStartWeek,
                CWRenewalWeek:this.weeklyMarketDays[rentEndPeriodIndex +1].RentalEndDays,
                RentEndPeriodIndex:rentEndPeriodIndex
              }
              this.selectedWeeklyBooths.push(ob);
            }
          }
        });
        this.applyRentalRenewalAvailability();
        this.loaderIcon = Promise.resolve(false);
        this.handleWeeklyEndDateChange();
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  async handleWeeklyEndDateChange() {
    this.renewAllBoothsFromGrid = true;
    this.vendorRentalDays = [];
    this.marketDayCountForResale = 0;

    let rentalDates = this.calculateRentalDates();
    await this.processVendorRentalDays(rentalDates);
  }

  calculateRentalDates() {
    let rentalDates = [];
    const selectedBooths = this.selectedWeeklyBooths.filter(e => e.NewBooth || e.ExtendRental);

    selectedBooths.forEach(record => {
      const selectedDayOfWeek = this.getSelectedDayOfWeek(record);
      let currentDay = new Date(record.RentalStartDate);
      const endDate = new Date(record.RentalEndDate);

      while (currentDay <= endDate) {
        if (currentDay.getDay() === selectedDayOfWeek) {
          rentalDates.push({ startDate: this.datePipe.transform(currentDay, 'MMM d, y') });
        }
        currentDay.setDate(currentDay.getDate() + 1);
      }
    });

    return rentalDates;
  }

  getSelectedDayOfWeek(record) {
    return record.Sunday ? 0 :
      record.Monday ? 1 :
        record.Tuesday ? 2 :
          record.Wednesday ? 3 :
            record.Thursday ? 4 :
              record.Friday ? 5 :
                record.Saturday ? 6 : null;
  }

  async processVendorRentalDays(rentalDates) {
    rentalDates.forEach(date => {
      const targetDateString = this.datePipe.transform(date.startDate, "MM/dd/yyyy");
      if (!this.vendorRentalDays.some(el => this.datePipe.transform(el.VendorRentalDate, "MM/dd/yyyy") === targetDateString)) {
        this.vendorRentalDays.push({ VendorRentalDate: targetDateString });
        this.marketDayCountForResale += 1;
        if (this.marketDayCountForResale > this.DaysSellWithoutResaleNumber && this.marketDayCountForResale > this.DaysSellWithoutBusiLicNumber) {
          return;
        }
      }
    });

    const res = await this.getVendorRentalDays();

    if (res && res.length > 0) {
      res.forEach(el => {
        const targetDateString = this.datePipe.transform(el.VendorRentalDate, "MM/dd/yyyy");
        if (!this.vendorRentalDays.some(data => this.datePipe.transform(data.VendorRentalDate, "MM/dd/yyyy") === targetDateString)) {
          this.vendorRentalDays.push({ VendorRentalDate: targetDateString });
          this.marketDayCountForResale += 1;
        }
      });
    }

    await this.checkResaleAndBusinessLicense();
  }

  showModal(modal) {
    modal.classList.add('show');
    modal.style.display = 'block';
  }

  async checkResaleAndBusinessLicense() {
    if (this.ResaleNumberRequired && !this.exemptResale && !this.resaleNo && this.marketDayCountForResale > this.DaysSellWithoutResaleNumber && !this.resaleOptionSelected) {
      this.resaleModalFlow = {
        resume: () => this.checkResaleAndBusinessLicense(),
        cancel: () => this.revertPendingWeeklyExtensions()
      };
      this.showModal(this.modalResaleNo.nativeElement);
    } else if (this.BusinessLicenseNumberRequired && this.marketDayCountForResale > this.DaysSellWithoutBusiLicNumber) {
      if (!this.businessLicenseNumber) {
        await this.promptBusinessLicense();
      } else if (!this.businessLicenseExpiryDate || new Date(this.businessLicenseExpiryDate) < new Date()) {
        await this.promptExpiredBusinessLicense();
      } else {
        this.renewWeeklyAllBooths();
      }
    } else {
      this.renewWeeklyAllBooths();
    }
  }

  async promptBusinessLicense() {
    this.loaderIcon = Promise.resolve(false);
    Swal.fire({
      title: $localize`Warning`,
      text: $localize`Business License is required! Please contact the market`,
      icon: "warning",
      confirmButtonText: $localize`Ok`,
    });
    this.revertPendingWeeklyExtensions();
    return;
  }

  async promptExpiredBusinessLicense() {
    this.loaderIcon = Promise.resolve(false);
    Swal.fire({
      title: $localize`Warning`,
      text: $localize`Business License is expired! Please contact the market`,
      icon: "warning",
      confirmButtonText: $localize`Ok`,
    });
    this.revertPendingWeeklyExtensions();
    return;
  }

  // Undo pending renewals for every CW (Weekly) booth marked for renewal,
  // used when the "renew all" bulk flow is blocked before a specific record
  // is selected (no single extendRentalRecord to target).
  private revertPendingWeeklyExtensions() {
    this.selectedWeeklyBooths
      .filter(record => record.Reservation)
      .forEach(record => {
        record.Reservation = false;
        this.updateWeeklyRentalRecord(record);
      });
  }

  async renewWeeklyAllBooths(){
    var nonAvailableBooths = [];
    for (const item of this.selectedWeeklyBooths) {
      if (new Date(item.RentEndPeriod.split('-')[0]) < new Date(item.CWRenewalWeek.split('-')[0])
        && !item.Drop && item.Reservation) {
        if (item.WeeklyRentalId != 0)
          var recordExist = this.selectedWeeklyBooths.findIndex(e => e.RentStartPeriod == item.RentStartPeriod && e.RentEndPeriod == item.RentEndPeriod
            && e.BoothNumber == item.BoothNumber && e.WeeklyRentalId == item.WeeklyRentalId);
        else
          var recordExist = this.selectedWeeklyBooths.findIndex(e => e.RentStartPeriod == item.RentStartPeriod && e.RentEndPeriod == item.RentEndPeriod
            && e.BoothNumber == item.BoothNumber && e.RentalMarketDay == item.RentalMarketDay);

        if (recordExist != -1) {
          var marketDay;
          var selectedDayOfWeek;
          if (this.selectedWeeklyBooths[recordExist].Sunday == true) {
            marketDay = 'Sun'
            selectedDayOfWeek = 0;
          }
          else if (this.selectedWeeklyBooths[recordExist].Monday == true) {
            marketDay = 'Mon'
            selectedDayOfWeek = 1;
          }
          else if (this.selectedWeeklyBooths[recordExist].Tuesday == true) {
            marketDay = 'Tue'
            selectedDayOfWeek = 2;
          }
          else if (this.selectedWeeklyBooths[recordExist].Wednesday == true) {
            marketDay = 'Wed'
            selectedDayOfWeek = 3;
          }
          else if (this.selectedWeeklyBooths[recordExist].Thursday == true) {
            marketDay = 'Thu'
            selectedDayOfWeek = 4;
          }
          else if (this.selectedWeeklyBooths[recordExist].Friday == true) {
            marketDay = 'Fri'
            selectedDayOfWeek = 5;
          }
          else if (this.selectedWeeklyBooths[recordExist].Saturday == true) {
            marketDay = 'Sat'
            selectedDayOfWeek = 6;
          }

          var selectedRentalDates = [];
          const startDate = new Date(this.selectedWeeklyBooths[recordExist].RentStartPeriod.split('-')[0]);
          const endDate = new Date(item.CWRenewalWeek.split("-")[1]);
          while (new Date(startDate) <= new Date(endDate)) {
            if (startDate.getDay() === selectedDayOfWeek) {
              selectedRentalDates.push(new Date(startDate));
            }
            startDate.setDate(startDate.getDate() + 1);
          }

          var currentRentedEndDate = new Date(this.selectedWeeklyBooths[recordExist].RentEndPeriod.split("-")[1]);
          const filteredRentalDates = selectedRentalDates.filter(rentalDate => rentalDate > currentRentedEndDate);
          var obj1 = {
            RentalDates: filteredRentalDates,
            BoothNumber: this.selectedWeeklyBooths[recordExist].BoothNumber
          }

          const res = await this.rentalService.checkRentalExits(this.marketId,obj1).toPromise();
          if (!res.Success) {
            var RentAmount = this.selectedWeeklyBooths[recordExist].Rent;
            var SalesTax = this.selectedWeeklyBooths[recordExist].SalesTax;
            var CityTax = this.selectedWeeklyBooths[recordExist].CityTax;
            var JanRentAmount = this.selectedWeeklyBooths[recordExist].January ?? 0;
            var FebRentAmount = this.selectedWeeklyBooths[recordExist].February ?? 0;
            var MarRentAmount = this.selectedWeeklyBooths[recordExist].March ?? 0;
            var AprRentAmount = this.selectedWeeklyBooths[recordExist].April ?? 0;
            var MayRentAmount = this.selectedWeeklyBooths[recordExist].May ?? 0;
            var JunRentAmount = this.selectedWeeklyBooths[recordExist].June ?? 0;
            var JulRentAmount = this.selectedWeeklyBooths[recordExist].July ?? 0;
            var AugRentAmount = this.selectedWeeklyBooths[recordExist].August ?? 0;
            var SepRentAmount = this.selectedWeeklyBooths[recordExist].September ?? 0;
            var OctRentAmount = this.selectedWeeklyBooths[recordExist].October ?? 0;
            var NovRentAmount = this.selectedWeeklyBooths[recordExist].November ?? 0;
            var DecRentAmount = this.selectedWeeklyBooths[recordExist].December ?? 0;

            this.totalRentalCharge -= this.getActualAmountFromInp(RentAmount);
            this.totalSalesTax -= this.getActualAmountFromInp(SalesTax);
            this.totalSecondLeveltax -= this.getActualAmountFromInp(CityTax);
            this.updateCharges();

            var extendRentalStartPeriod;
            if (!this.selectedWeeklyBooths[recordExist].NewBooth && this.selectedWeeklyBooths[recordExist].Status != "R") {
              extendRentalStartPeriod = new Date(this.selectedWeeklyBooths[recordExist].RentalSavedEndDate.split("-")[1])
              extendRentalStartPeriod.setDate(extendRentalStartPeriod.getDate() + 1);
            }
            else {
              extendRentalStartPeriod = new Date(this.selectedWeeklyBooths[recordExist].RentStartPeriod.split("-")[0]);
            }

            var obj = {
              BoothTypeId: this.selectedWeeklyBooths[recordExist].BoothTypeId,
              VendorId: this.vendorId,
              RentalStartPeriod: new Date(extendRentalStartPeriod),
              RentalMarketDay: marketDay,
              RentalEndPeriod: new Date(item.CWRenewalWeek.split("-")[1]),
              JanRent: this.getActualAmountFromInp(JanRentAmount),
              FebRent: this.getActualAmountFromInp(FebRentAmount),
              MarRent: this.getActualAmountFromInp(MarRentAmount),
              AprRent: this.getActualAmountFromInp(AprRentAmount),
              MayRent: this.getActualAmountFromInp(MayRentAmount),
              JunRent: this.getActualAmountFromInp(JunRentAmount),
              JulRent: this.getActualAmountFromInp(JulRentAmount),
              AugRent: this.getActualAmountFromInp(AugRentAmount),
              SepRent: this.getActualAmountFromInp(SepRentAmount),
              OctRent: this.getActualAmountFromInp(OctRentAmount),
              NovRent: this.getActualAmountFromInp(NovRentAmount),
              DecRent: this.getActualAmountFromInp(DecRentAmount),
            }
            const res = await this.rentalService.getBoothRentalWeeklyCharges(this.marketId, obj).toPromise();
            this.selectedWeeklyBooths[recordExist].RentEndPeriod = item.CWRenewalWeek;
            this.selectedWeeklyBooths[recordExist].January = this.customCurrency.transform(res.JanRent);
            this.selectedWeeklyBooths[recordExist].February = this.customCurrency.transform(res.FebRent);
            this.selectedWeeklyBooths[recordExist].March = this.customCurrency.transform(res.MarRent);
            this.selectedWeeklyBooths[recordExist].April = this.customCurrency.transform(res.AprRent);
            this.selectedWeeklyBooths[recordExist].May = this.customCurrency.transform(res.MayRent);
            this.selectedWeeklyBooths[recordExist].June = this.customCurrency.transform(res.JunRent);
            this.selectedWeeklyBooths[recordExist].July = this.customCurrency.transform(res.JulRent);
            this.selectedWeeklyBooths[recordExist].August = this.customCurrency.transform(res.AugRent);
            this.selectedWeeklyBooths[recordExist].September = this.customCurrency.transform(res.SepRent);
            this.selectedWeeklyBooths[recordExist].October = this.customCurrency.transform(res.OctRent);
            this.selectedWeeklyBooths[recordExist].November = this.customCurrency.transform(res.NovRent);
            this.selectedWeeklyBooths[recordExist].December = this.customCurrency.transform(res.DecRent);
            this.selectedWeeklyBooths[recordExist].Rent = this.customCurrency.transform(res.Rent);
            this.selectedWeeklyBooths[recordExist].SalesTax = this.customCurrency.transform(res.SalesTax);
            this.selectedWeeklyBooths[recordExist].CityTax = this.customCurrency.transform(res.CityTax);
            this.selectedWeeklyBooths[recordExist].JanuaryMonthPresent = res.JanuaryMonthPresent;
            this.selectedWeeklyBooths[recordExist].FebruaryMonthPresent = res.FebruaryMonthPresent;
            this.selectedWeeklyBooths[recordExist].MarchMonthPresent = res.MarchMonthPresent;
            this.selectedWeeklyBooths[recordExist].AprilMonthPresent = res.AprilMonthPresent;
            this.selectedWeeklyBooths[recordExist].MayMonthPresent = res.MayMonthPresent;
            this.selectedWeeklyBooths[recordExist].JuneMonthPresent = res.JuneMonthPresent;
            this.selectedWeeklyBooths[recordExist].JulyMonthPresent = res.JulyMonthPresent;
            this.selectedWeeklyBooths[recordExist].AugustMonthPresent = res.AugustMonthPresent;
            this.selectedWeeklyBooths[recordExist].SeptemberMonthPresent = res.SeptemberMonthPresent;
            this.selectedWeeklyBooths[recordExist].OctoberMonthPresent = res.OctoberMonthPresent;
            this.selectedWeeklyBooths[recordExist].NovemberMonthPresent = res.NovemberMonthPresent;
            this.selectedWeeklyBooths[recordExist].DecemberMonthPresent = res.DecemberMonthPresent;
            this.selectedWeeklyBooths[recordExist].DisableJanMonth = res.JanRent || res.JanRent == 0? false : true;
            this.selectedWeeklyBooths[recordExist].DisableFebMonth = res.FebRent || res.FebRent == 0? false : true;
            this.selectedWeeklyBooths[recordExist].DisableMarMonth = res.MarRent || res.MarRent == 0? false : true;
            this.selectedWeeklyBooths[recordExist].DisableAprMonth = res.AprRent || res.AprRent == 0? false : true;
            this.selectedWeeklyBooths[recordExist].DisableMayMonth = res.MayRent || res.MayRent == 0? false : true;
            this.selectedWeeklyBooths[recordExist].DisableJunMonth = res.JunRent || res.JunRent == 0? false : true;
            this.selectedWeeklyBooths[recordExist].DisableJulMonth = res.JulRent || res.JulRent == 0? false : true;
            this.selectedWeeklyBooths[recordExist].DisableAugMonth = res.AugRent || res.AugRent == 0? false : true;
            this.selectedWeeklyBooths[recordExist].DisableSepMonth = res.SepRent || res.SepRent == 0? false : true;
            this.selectedWeeklyBooths[recordExist].DisableOctMonth = res.OctRent || res.OctRent == 0? false : true;
            this.selectedWeeklyBooths[recordExist].DisableNovMonth = res.NovRent || res.NovRent == 0? false : true;
            this.selectedWeeklyBooths[recordExist].DisableDecMonth = res.DecRent || res.DecRent == 0? false : true;
            this.selectedWeeklyBooths[recordExist].ExtendRental = true;
            this.selectedWeeklyBooths[recordExist].TaxModel = res.TaxModel;

            this.totalRentalCharge += this.getActualAmountFromInp(res.Rent);
            this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
            this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
            this.updateCharges();
          }
          else {
            nonAvailableBooths.push(this.selectedWeeklyBooths[recordExist].BoothNumber);
          }
        }
      }
    }

    if (nonAvailableBooths.length > 0) {
      const nonAvailableBoothsString = nonAvailableBooths.join(', ');
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Cannot be renewed further as the booth number ` + nonAvailableBoothsString + ` is not available`,
        icon: "info",
        confirmButtonText: $localize`Ok`,
      });
    }
  }

  getWeeklyOtherRentals(){
    this.loaderIcon = Promise.resolve(true);
    this.selectedOtherItems = [];
    const weekStartDate = this.weeklyMarketDays[0].RentalStartDays.split('-')[0];
    const weekEndDate =   this.weeklyMarketDays[0].RentalStartDays.split('-')[1];
    const sub = this.rentalService.getWeeklyOtherRentals(this.marketId,this.vendorId).subscribe((res: any[]) => {
      this.allrentedOtherItems = res;
      if (res) {
        res.forEach((el) => {
          var RentalWeekRecord = this.weeklyMarketDays.filter(date => this.datePipe.transform(new Date(date.RentalStartDays.split('-')[0]), 'MM/dd/yyyy') <= this.datePipe.transform(new Date(el.RentalWeekDay), 'MM/dd/yyyy')
            && this.datePipe.transform(new Date(date.RentalStartDays.split('-')[1]), 'MM/dd/yyyy') >= this.datePipe.transform(new Date(el.RentalWeekDay), 'MM/dd/yyyy'))
          if (RentalWeekRecord.length > 0)
            var RentalWeek = RentalWeekRecord[0].RentalStartDays;
          const rentEndPeriodIndex = this.weeklyMarketDays.findIndex(e=>e.RentalEndDays == RentalWeek);
          const renewalStartWeek = this.weeklyMarketDays[rentEndPeriodIndex +1].RentalEndDays;

          if (new Date(el.RentalWeekDay) >= new Date(weekStartDate)) {
            const index = this.selectedOtherItems.findIndex(item => item.Id === el.OtherItemId && item.RentalWeek == el.RentalWeek && item.Reference == el.Reference && item.BoothNo == el.BoothNumber && item.Recurring == el.Recurring);
            if (index !== -1) {
              this.selectedOtherItems[index].Quantity += el.Quantity;
              this.selectedOtherItems[index].WeeklyOtherRentalIds += ',' + el.OtherRentalId
            }
            const ob = {
              Id: el.OtherItemId,
              WeekOtherRentalId: el.OtherRentalId,
              OtherItem: el.OtherItemName,
              OtherItemCharge: this.customCurrency.transform('0'),
              Quantity: el.Quantity,
              OtherItemtotal: this.customCurrency.transform('0'),
              RentalWeek: RentalWeek,
              SalesTax: this.customCurrency.transform('0'),
              CityTax: this.customCurrency.transform('0'),
              CurrentRentalWeek: RentalWeek,
              CurrentOtherItemtotal: this.customCurrency.transform(el.OtherCharge.toString()),
              CurrentSalesTax: this.customCurrency.transform(el.SalesTax.toString()),
              CurrentSecLevelTax: this.customCurrency.transform(el.SecLevelTax.toString()),
              BoothNo: el.BoothNumber,
              Recurring: el.Recurring,
              NewItem: false,
              Reference: el.Reference,
              WeeklyOtherRentalIds: el.OtherRentalId.toString(),
              Status: "B",
              RentEndPeriodIndex: rentEndPeriodIndex,
              RenewalStartWeek: renewalStartWeek,
              CWRenewalWeek: renewalStartWeek,
              BookingCanExtend: true
            }
            this.selectedOtherItems.push(ob);
          }
          else {
            var obj = {
              MarketId: this.marketId,
              OtherItemId: el.OtherItemId,
              VendorId: this.vendorId,
              Quantity: el.Quantity,
              OtherItemCharge: el.OtherCharge
            }

            this.rentalService.getOtherItemsRentalCharges(obj).subscribe((res: any) => {
              const ob = {
                Id: el.OtherItemId,
                MonthOtherRentalId: el.OtherRentalId,
                OtherItem: el.OtherItemName,
                OtherItemCharge: this.customCurrency.transform(el.OtherCharge),
                Quantity: el.Quantity,
                OtherItemtotal: this.customCurrency.transform((el.OtherCharge * el.Quantity).toString()),
                RentalWeek: this.weeklyMarketDays[0].RentalStartDays,
                SalesTax: this.customCurrency.transform(res.SalesTax.toString()),
                CityTax: this.customCurrency.transform(res.CityTax.toString()),
                BoothNo: el.BoothNumber ? el.BoothNumber : "none",
                Recurring: el.Recurring,
                Reference: el.Reference,
                NewItem: false,
                MonthlyRentalIds: '',
                Status: "R",
                RentEndPeriodIndex:rentEndPeriodIndex
              }
              this.selectedOtherItems.push(ob);
              const OtherItemtotal = el.OtherCharge * el.Quantity;
              this.totalOtherRentalCharge += OtherItemtotal;
              this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
              this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
              this.totalCharge = this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;
              this.bookingDetailsForm.patchValue({
                otherCharge: this.customCurrency.transform(this.totalOtherRentalCharge.toString()),
                totalSalesTax: this.customCurrency.transform(this.totalSalesTax.toString()),
                totalSecondLeveltax: this.customCurrency.transform(this.totalSecondLeveltax.toString()),
                totalCharge: this.customCurrency.transform(this.totalCharge.toString())
              });
            });
          }
        });
        this.renewWeeklyOtherCharges();
        this.loaderIcon = Promise.resolve(false);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  renewWeeklyOtherCharges() {
    if (this.selectedOtherItems.length > 0) {
      this.proceedRenewingWeeklyOtherCharges();
    }
  }

  updateWeeklyRentalRecord(record) {
    if (record.Reservation && this.allowWeeklyRentalRenewal) {
      const rentEndPeriodIndex = this.weeklyMarketDays.findIndex(e => e.RentalEndDays == record.RentEndPeriod);
      const renewalStartWeek = this.weeklyMarketDays[rentEndPeriodIndex + 1].RentalEndDays;
      record.BookingCanExtend = true;
      record.RenewalStartWeek = renewalStartWeek
      record.CWRenewalWeek = renewalStartWeek;
      record.RentEndPeriodIndex = rentEndPeriodIndex
      this.extendWeeklyRental(record);
      this.applyOnlineBookingFeeIfNeeded();
    }
    else {
      record.BookingCanExtend = false;
      record.RenewalStartWeek = "This booking cannot be extended further!";
      record.CWRenewalWeek = record.CurrentRentEndPeriod;
      record.RentEndPeriod = record.CurrentRentEndPeriod;
      this.totalRentalCharge -= this.getActualAmountFromInp(record.Rent);
      this.totalSalesTax -= this.getActualAmountFromInp(record.SalesTax);
      this.totalSecondLeveltax -= this.getActualAmountFromInp(record.CityTax);
      this.updateCharges();
      record.Rent = this.customCurrency.transform("0");
      this.applyOnlineBookingFeeIfNeeded();
    }
  }

  extendWeeklyRental(extendRentalRecord) {
    if (extendRentalRecord) {
      var recordExist = this.selectedWeeklyBooths.findIndex(e => e.RentStartPeriod == extendRentalRecord.RentStartPeriod && e.RentEndPeriod == extendRentalRecord.RentEndPeriod
        && e.BoothNumber == extendRentalRecord.BoothNumber)
      if (recordExist != -1) {
        const rentalDates = [];
        const currentMonthRentalDates = [];
        var rentalstartDate;
        var marketDays = 0;
        var marketDay;

        if (this.selectedWeeklyBooths[recordExist].Sunday == true) {
          marketDay = 'Sun'
        }
        else if (this.selectedWeeklyBooths[recordExist].Monday == true) {
          marketDay = 'Mon'
        }
        else if (this.selectedWeeklyBooths[recordExist].Tuesday == true) {
          marketDay = 'Tue'
        }
        else if (this.selectedWeeklyBooths[recordExist].Wednesday == true) {
          marketDay = 'Wed'
        }
        else if (this.selectedWeeklyBooths[recordExist].Thursday == true) {
          marketDay = 'Thu'
        }
        else if (this.selectedWeeklyBooths[recordExist].Friday == true) {
          marketDay = 'Fri'
        }
        else if (this.selectedWeeklyBooths[recordExist].Saturday == true) {
          marketDay = 'Sat'
        }

        var RentAmount = this.selectedWeeklyBooths[recordExist].Rent;
        var SalesTax = this.selectedWeeklyBooths[recordExist].SalesTax;
        var CityTax = this.selectedWeeklyBooths[recordExist].CityTax;

        this.totalRentalCharge -= this.getActualAmountFromInp(RentAmount);
        this.totalSalesTax -= this.getActualAmountFromInp(SalesTax);
        this.totalSecondLeveltax -= this.getActualAmountFromInp(CityTax);
        this.updateCharges();

        var extendRentalStartPeriod;
        if (!this.selectedWeeklyBooths[recordExist].NewBooth  && this.selectedWeeklyBooths[recordExist].Status != "R") {
          extendRentalStartPeriod = new Date(this.selectedWeeklyBooths[recordExist].RentalSavedEndDate.split("-")[1]);
          extendRentalStartPeriod.setDate(extendRentalStartPeriod.getDate() + 1);
        }
        else {
          extendRentalStartPeriod = new Date(this.selectedWeeklyBooths[recordExist].RentStartPeriod.split("-")[0]);
        }

        var obj = {
          BoothTypeId: this.selectedWeeklyBooths[recordExist].BoothTypeId,
          VendorId: this.vendorId,
          RentalMarketDay: marketDay,
          RentalStartPeriod: new Date(extendRentalStartPeriod),
          RentalEndPeriod: new Date(extendRentalRecord.CWRenewalWeek.split("-")[1]),
          PerDiemApplicable: false
        }
        this.rentalService.getBoothRentalWeeklyCharges(this.marketId,obj).subscribe((res: any) => {
          this.selectedWeeklyBooths[recordExist].RentEndPeriod =extendRentalRecord.CWRenewalWeek;
          this.selectedWeeklyBooths[recordExist].January = this.customCurrency.transform(res.JanRent);
          this.selectedWeeklyBooths[recordExist].February = this.customCurrency.transform(res.FebRent);
          this.selectedWeeklyBooths[recordExist].March = this.customCurrency.transform(res.MarRent);
          this.selectedWeeklyBooths[recordExist].April = this.customCurrency.transform(res.AprRent);
          this.selectedWeeklyBooths[recordExist].May = this.customCurrency.transform(res.MayRent);
          this.selectedWeeklyBooths[recordExist].June = this.customCurrency.transform(res.JunRent);
          this.selectedWeeklyBooths[recordExist].July = this.customCurrency.transform(res.JulRent);
          this.selectedWeeklyBooths[recordExist].August = this.customCurrency.transform(res.AugRent);
          this.selectedWeeklyBooths[recordExist].September = this.customCurrency.transform(res.SepRent);
          this.selectedWeeklyBooths[recordExist].October = this.customCurrency.transform(res.OctRent);
          this.selectedWeeklyBooths[recordExist].November = this.customCurrency.transform(res.NovRent);
          this.selectedWeeklyBooths[recordExist].December = this.customCurrency.transform(res.DecRent);
          this.selectedWeeklyBooths[recordExist].Rent = this.customCurrency.transform(res.Rent);
          this.selectedWeeklyBooths[recordExist].SalesTax = this.customCurrency.transform(res.SalesTax);
          this.selectedWeeklyBooths[recordExist].CityTax = this.customCurrency.transform(res.CityTax);
          this.selectedWeeklyBooths[recordExist].JanuaryMonthPresent = res.JanuaryMonthPresent;
          this.selectedWeeklyBooths[recordExist].FebruaryMonthPresent = res.FebruaryMonthPresent;
          this.selectedWeeklyBooths[recordExist].MarchMonthPresent = res.MarchMonthPresent;
          this.selectedWeeklyBooths[recordExist].AprilMonthPresent = res.AprilMonthPresent;
          this.selectedWeeklyBooths[recordExist].MayMonthPresent = res.MayMonthPresent;
          this.selectedWeeklyBooths[recordExist].JuneMonthPresent = res.JuneMonthPresent;
          this.selectedWeeklyBooths[recordExist].JulyMonthPresent = res.JulyMonthPresent;
          this.selectedWeeklyBooths[recordExist].AugustMonthPresent = res.AugustMonthPresent;
          this.selectedWeeklyBooths[recordExist].SeptemberMonthPresent = res.SeptemberMonthPresent;
          this.selectedWeeklyBooths[recordExist].OctoberMonthPresent = res.OctoberMonthPresent;
          this.selectedWeeklyBooths[recordExist].NovemberMonthPresent = res.NovemberMonthPresent;
          this.selectedWeeklyBooths[recordExist].DecemberMonthPresent = res.DecemberMonthPresent;
          this.selectedWeeklyBooths[recordExist].DisableJanMonth = res.JanRent || res.JanRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableFebMonth = res.FebRent || res.FebRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableMarMonth = res.MarRent || res.MarRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableAprMonth = res.AprRent || res.AprRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableMayMonth = res.MayRent || res.MayRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableJunMonth = res.JunRent || res.JunRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableJulMonth = res.JulRent || res.JulRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableAugMonth = res.AugRent || res.AugRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableSepMonth = res.SepRent || res.SepRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableOctMonth = res.OctRent || res.OctRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableNovMonth = res.NovRent || res.NovRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableDecMonth = res.DecRent || res.DecRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].ExtendRental = true;

          this.totalRentalCharge += this.getActualAmountFromInp(res.Rent);
          this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
          this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
          this.updateCharges();
        });
      }
    }
  }

  extendWeeklyOtherRental(item) {
    const cuurentWeek = new Date(item.RentalWeek.split('-')[1]);
    if (cuurentWeek < new Date(item.CWRenewalWeek.split('-')[1]) && item.Recurring && this.allowWeeklyRentalRenewal) {
      var nextDate = this.addDays(new Date(item.RentalWeek.split('-')[0]), 7);
      var rentalWeekDate = this.weeklyMarketDays.filter(date => this.datePipe.transform(new Date(date.RentalEndDays.split('-')[0]), 'MM/dd/yyyy') <= this.datePipe.transform(new Date(nextDate), 'MM/dd/yyyy')
        && this.datePipe.transform(new Date(date.RentalEndDays.split('-')[1]), 'MM/dd/yyyy') >= this.datePipe.transform(new Date(nextDate), 'MM/dd/yyyy'))
      if (rentalWeekDate.length > 0)
        var rentalStartWeek = rentalWeekDate[0].RentalStartDays;

      var otherItemCharge = this.otherItemList.filter(e => e.Id == item.Id)[0].OtherItemCharge;
      if (!this.masterRentChargeforResOtherItems && this.allrentedOtherItems.length > 0) {
        otherItemCharge = this.customCurrency.transform(this.allrentedOtherItems.filter(e => e.OtherItemId == item.Id)[0].OtherCharge);
      }
      var obj = {
        MarketId: this.marketId,
        OtherItemId: item.Id,
        VendorId: this.vendorId,
        Quantity: item.Quantity,
        OtherItemCharge: this.getActualAmountFromInp(otherItemCharge)
      }

      this.rentalService.getOtherItemsRentalCharges(obj).subscribe((res: any) => {
        const isNegative = otherItemCharge.includes('(') && otherItemCharge.includes(')');
        const totalValue = parseFloat(otherItemCharge.replace(/[^0-9.-]/g, ''));
        const finalCharge = isNegative ? -totalValue : totalValue;
        item.OtherItemtotal =this.customCurrency.transform((parseFloat(item.OtherItemtotal.replace(/[^0-9.-]/g, '')) + (finalCharge * item.Quantity)).toString());
        item.Quantity += item.Quantity;
        item.OtherItemCharge = otherItemCharge;
        item.MonthlyRentalIds += ',' + item.Id
        item.CWRenewalWeek = rentalStartWeek;

        this.totalOtherRentalCharge += this.getActualAmountFromInp(item.OtherItemtotal);
        this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
        this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
        this.updateCharges();
      });
    }
    else {
      item.BookingCanExtend = false;
      item.RenewalStartMonth = "This booking cannot be extended further!";
      item.MonthlyRenewalMonth = item.RentalMonth;
    }
  }

  updateWeeklyOtherItemRecord(record){
    if (record.Recurring && this.allowOtherItemRenewal) {
      const rentEndPeriodIndex = this.weeklyMarketDays.findIndex(e => e.RentalEndDays == record.RentalWeek);
      const renewalStartWeek = this.weeklyMarketDays[rentEndPeriodIndex + 1].RentalEndDays;
      record.BookingCanExtend = true;
      record.RenewalStartWeek = renewalStartWeek
      record.CWRenewalWeek = renewalStartWeek;
      record.RentEndPeriodIndex = rentEndPeriodIndex
      this.extendWeeklyOtherRental(record);
      this.applyOnlineBookingFeeIfNeeded();
    }
    else {
      if (this.preventVendorUncheckOtherItemRenewal && !record.Recurring) {
        setTimeout(() => record.Recurring = true);
        return;
      }
      record.BookingCanExtend = false;
      record.RenewalStartWeek = "This booking cannot be extended further!";
      record.CWRenewalWeek = record.RentalWeek;
      this.totalOtherRentalCharge -= this.getActualAmountFromInp(record.OtherItemtotal);
      this.totalSalesTax -= this.getActualAmountFromInp(record.SalesTax);
      this.totalSecondLeveltax -= this.getActualAmountFromInp(record.CityTax);
      this.updateCharges();
      record.Rent = this.customCurrency.transform("0");
      this.applyOnlineBookingFeeIfNeeded();
    }
  }

  addDays(date: Date, days: number): Date {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  proceedRenewingWeeklyOtherCharges(){
    for(const item of this.selectedOtherItems){
      if (new Date(item.RentalWeek.split('-')[0]) < new Date(item.CWRenewalWeek.split('-')[0])
        && item.Recurring && this.allowOtherItemRenewal) {
        var nextDate = this.addDays(new Date(item.RentalWeek.split('-')[0]), 7);
        var rentalWeekDate = this.weeklyMarketDays.filter(date => this.datePipe.transform(new Date(date.RentalEndDays.split('-')[0]), 'MM/dd/yyyy') <= this.datePipe.transform(new Date(nextDate), 'MM/dd/yyyy')
          && this.datePipe.transform(new Date(date.RentalEndDays.split('-')[1]), 'MM/dd/yyyy') >= this.datePipe.transform(new Date(nextDate), 'MM/dd/yyyy'))
        if (rentalWeekDate.length > 0)
          var rentalStartWeek = rentalWeekDate[0].RentalStartDays;

        var recordExist = this.selectedOtherItems.findIndex(e => e.RentalWeek == rentalStartWeek && e.Id == item.Id && e.Reference == item.Reference && e.BoothNumber == item.item.BoothNo)
        var otherItemCharge = this.otherItemList.filter(e => e.Id == item.Id)[0].OtherItemCharge;
        if (!this.masterRentChargeforResOtherItems && this.allrentedOtherItems.length > 0) {
          otherItemCharge = this.customCurrency.transform(this.allrentedOtherItems.filter(e => e.OtherItemId == item.Id)[0].OtherCharge);
        }
        var obj = {
          MarketId: this.marketId,
          OtherItemId: item.Id,
          VendorId: this.vendorId,
          Quantity: item.Quantity,
          OtherItemCharge: this.getActualAmountFromInp(otherItemCharge)
        }
        this.rentalService.getOtherItemsRentalCharges(obj).subscribe((res: any) => {
          if (recordExist == -1) {
            const isNegative = otherItemCharge.includes('(') && otherItemCharge.includes(')');
            const totalValue = parseFloat(otherItemCharge.replace(/[^0-9.-]/g, ''));
            const finalCharge = isNegative ? -totalValue : totalValue;
            item.OtherItemtotal = this.customCurrency.transform((finalCharge * item.Quantity).toString());
            const ob = {
              Id: item.Id,
              WeekOtherRentalId: 0,
              OtherItem: item.OtherItem,
              OtherItemCharge: otherItemCharge,
              Quantity: item.Quantity,
              OtherItemtotal: item.OtherItemtotal,
              RentalWeek: rentalStartWeek,
              SalesTax: this.customCurrency.transform(res.SalesTax.toString()),
              CityTax: this.customCurrency.transform(res.CityTax.toString()),
              BoothNo: item.othChgBooths ?? "none",
              Recurring: item.Recurring,
              NewItem: true,
              Reference: item.Reference,
              WeeklyOtherRentalIds: ''
            }
            this.selectedOtherItems.push(JSON.parse(JSON.stringify(ob)));
          }
          this.totalOtherRentalCharge += this.getActualAmountFromInp(item.OtherItemtotal);
          this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
          this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
          this.updateCharges();
        });
      }
      else{
        item.BookingCanExtend = false;
        item.RenewalStartWeek = "This booking cannot be extended further!";
        item.CWRenewalWeek = item.RentalWeek;
      }
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
